import { Component, OnInit, QueryList } from '@angular/core';
import { DataService } from '../../services/data.service';
import { SpinnerService, Message } from 'shared-components';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-central-estadisticas',
    templateUrl: './central-estadisticas.component.html'
})
export class CentralEstadisticasComponent implements OnInit {

    private _filters;
    public filtersVisible = false;
    public filtersForm: UntypedFormGroup;

    public mensajes = new Array<Message>();
    public showError: boolean;
    public showWarning: boolean;

// #region declaración de variables estadísitcas

    public filtroAnyo: boolean;
    public filtroPais: boolean;
    public filtroDenominacion: boolean;
    public filtroEtiquetador: boolean;

    public filterPaisDenominacion = false;
    public filterCampanyaPaisDenominacion = false;

    public filterEtiquetadores = false;
    public filterDesignacionesPD = false;
    public filterDesignacionesCPD = false;
    public filterCultivos = false;
    public filterEtiquetadoPD = false;
    public filterEtiquetadoCPD = false;
    public filterReetiquetado = false;
    public filterEtiquetas = false;

    public datosEtiquetadores;
    public graficasEtiquetadores;
    public etiquetadoresPaisPaises1;
    public etiquetadoresPaisPaisDenominaciones2;
    public etiquetadoresDenominacionDenominaciones1;
    public etiquetadoresPaisDenominacionPaises2;
    public etiquetadoresNumDenominacionesNumDenominaciones1;
    public etiquetadoresNumDenominacionesNumDenominacionPaises2;
    public etiquetadoresAnyoAcumuladoAnyos1;
    public etiquetadoresAnyoAnyos1;
    public etiquetadoresAnyoPaisesAnyo2;
    public etiquetadoresAnyoDenominacionesAnyo3;

    public datosDesignaciones;
    public graficasDesignaciones;
    public designacionesDesignacionesPaisPaises1;
    public designacionesDesignacionesPaisPaisDenominaciones2;
    public designacionesDesignacionesDenominacionDenominaciones1;
    public designacionesDesignacionesDenominacionDenominacionPaises2;
    public designacionesDesignacionesCampanyaCampanyas1;
    public designacionesDesignacionesCampanyaPaisesCampanya2;
    public designacionesDesignacionesCampanyaDenominacionesCampanya3;

    public datosDesignacionesFiltroCompleto;
    public graficasDesignacionesFiltroCompleto;
    public designacionesDesignacionesEtiquetadoresPaisDenominacionCampanya1 = [];
    public designacionesKilosEtiquetadoresPaisDenominacionCampanya1 = [];
    public designacionesKilosPaisPaisDenominaciones1;
    public designacionesKilosPaisPaisKilos2 = [];
    public designacionesKilosDenominacionDenominacionPaises1;
    public designacionesKilosDenominacionDenominacionKilos2 = [];
    public designacionesKilosCampanyasPaises1 = [];
    public designacionesKilosCampanyasDenominaciones2 = [];

    public datosCultivos;
    public graficasCultivos;
    public cultivosPaisPaises1;
    public cultivosPaisPaisDenominaciones2;
    public cultivosDenominacionDenominaciones1;
    public cultivosDenominacionDenominacionesPaises2;
    public cultivosCampanyasCampanyas1;
    public cultivosCampanyasPaisesCampanya2;
    public cultivosCultivosCampanyasDenominacionesCampanya3;
    public cultivosAforosPaisPaises1;
    public cultivosAforosPaisPaisDenominaciones2;
    public cultivosAforosDenominacionDenominaciones1;
    public cultivosAforosDenominacionDenominacionPaises2;
    public cultivosAforosCampanyasCampanyas1;
    public cultivosAforosCampanyasPaisesCampanya2;
    public cultivosAforosCampanyasDenominacionesCampanya3;
    public cultivosSuperficiePaisPaises1;
    public cultivosSuperficiePaisPaisDenominaciones2;
    public cultivosSuperficieDenominacionDenominaciones1;
    public cultivosSuperficieDenominacionDenominacionPaises2;
    public cultivosSuperficieCampanyasCampanyas1;
    public cultivosSuperficieCampanyasPaisesCampanya2;
    public cultivosSuperficieCampanyasDenominacionesCampanya3;

    public datosEtiquetado;
    public graficasEtiquetado;
    public etiquetadoKilosCampanyasPaises1 = [];
    public etiquetadoKilosCampanyasDenominaciones2 = [];
    public etiquetadoKilosCampanyasKilosPaisDenominaciones3 = [];

    public datosEtiquetadoFiltroCompleto;
    public graficasEtiquetadoFiltroCompleto;
    public etiquetadoKilosPaisPaisDenominacionesAnyoTotales1;
    public etiquetadoKilosPaisPaisKilosAnyoTotales2 = [];
    public etiquetadoKilosPaisPaisKilosAnyoDenominacion3 = [];
    public etiquetadoKilosDenominacionDenominacionPaisesAnyoTotales1;
    public etiquetadoKilosDenominacionDenominacionKilosAnyoTotales2 = [];
    public etiquetadoKilosDenominacionDenominacionKilosAnyoPais3 = [];
    public etiquetadoKilosCampanyasEtiquetadoresPaisDenominacion1 = [];
    public etiquetadoKilosEtiquetadoresAnyoPaisDenominacion1 = [];
    public etiquetadoKilosCampanyaPaisMesPaisMesTotales1 = [];
    public etiquetadoKilosCampanyaPaisMesPaisMes2 = [];
    public etiquetadoKilosCampanyaDenominacionMesDenominacionMesTotales1 = [];
    public etiquetadoKilosCampanyaDenominacionMesDenominacionMes2 = [];
    public etiquetadoPeriodoPaisPaisDenominacionAnyoTotales1 = [];
    public etiquetadoPeriodoPaisPaisAnyoDenominacion2 = [];
    public etiquetadoPeriodoDenominacionPaisDenominacionAnyoTotales1 = [];
    public etiquetadoPeriodoDenominacionDenominacionAnyoPais2 = [];

    public datosEtiquetadoFiltroEtiquetador;
    public graficasEtiquetadoFiltroEtiquetador;
    public etiquetadoKilosEtiquetadorCampanyasDenominaciones1 = [];
    public etiquetadoKilosEtiquetadorCampanyasKilosDenominaciones2 = [];

    public datosEtiquetadoFiltroEtiquetadorCompleto;
    public graficasEtiquetadoFiltroEtiquetadorCompleto;
    public etiquetadoPeriodoEtiquetadorEtiquetadorDenominacioAnyoPais1 = [];

    public numEtiquetadoresEtq;
    public numAlmacenesEtq;
    public numPaisesEtq;
    public numDenominacionesEtq;

    public numDesignacionesDsg;
    public numPaisesDsg;
    public numDenominacionesDsg;
    public designadosDsg;
    public aforoDsg;

    public numCultivosCul;
    public numPaisesCul;
    public numDenominacionesCul;
    public aforoCul;
    public superficieCul;

    public totalKilosDesignadosEto;
    public totalKilosNetosEto;
    public totalKilosCampoEto;
    public totalKilosExpedicionEto;

    public filtrosEtiquetador = {};
    public filtrosDesignacion = {};
    public filtrosCultivo = {};
    public filtrosEtiquetado = {};

    public tipoEstadisticas = 1;

    public toCloseSpinner = 0;

    public anyos = [];

    public otherFilter = 0;
    public filtrado: boolean;

    public initialStatePaises = 'noSelected';
    public initialStateDenominaciones = 'noSelected';
    public initialStateCampanyas = 'noSelected';

    public paises;
    public denominaciones;

//#endregion

    public colores = ["#1A443B", "#4F7C71", "#A7BDB8", "#144717", "#198A20",
                      "#7AD480", "#445A26", "#73933F", "#9CAE85", "#807B2A",
                      "#BCB65F", "#DDDAAF", "#623E2D", "#B77156", "#DCB09C",
                      "#5E4B17", "#7E6F45","#BFB7A2", "#304E2D", "#8CA48A",
                      "#94A092", "#00A039","#54916A", "#99D9B0", "#40683C",
                      "#668663", "#8BA39F","#1A443B", "#4F7C71", "#A7BDB8", "#144717", "#198A20",
                      "#7AD480", "#445A26", "#73933F", "#9CAE85", "#807B2A",
                      "#BCB65F", "#DDDAAF", "#623E2D", "#B77156", "#DCB09C",
                      "#5E4B17", "#7E6F45","#BFB7A2", "#304E2D", "#8CA48A",
                      "#94A092", "#00A039","#54916A", "#99D9B0", "#40683C",
                      "#668663", "#8BA39F"];

    public coloresSpline = ["#4F7C71", "#73933F"];

    public disabledAnyos: Subject<boolean> = new Subject();
    public disabledPaises: Subject<boolean> = new Subject();
    public disabledDenominaciones: Subject<boolean> = new Subject();
    public disabledEtiquetadores: Subject<boolean> = new Subject();

    constructor(
        private readonly _router: Router,
        private _fb: UntypedFormBuilder,
        private readonly _translate: TranslateService,
        private readonly _sessionContext: SessionContextService,
        private readonly _dataProvider: DataProvider,
        private readonly _dataService: DataService,
        private readonly _spinnerService: SpinnerService
    ) { }

    ngOnInit() {
        this.filtersForm = this._fb.group({
            anyoCampanya: [''],
            etiquetador: [''],
            pais: [''],
            denominacion: ['']
        });

        let ck = document.getElementsByTagName('app-multiselect-list');

        this.showWarning = true;
        this.mensajes = [];
        this.mensajes.push({ class: 'success', message: 'centralEstadisticas.filters.indiqueCriterio' });

        this.paises = this._dataProvider.paises;
        this.denominaciones = this._dataProvider.denominaciones;

        this._dataProvider.anyosCamanya.forEach((element, index) => {
            this.anyos.push({id: index, id_aux: element, des: element.toString()});
        });
    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    public get etiquetadores() {
        return this._dataProvider.etiquetadores;
    }

    public get anyosCampanya() {
        return this.anyos;
    }

    public get isSmallScreen(){
      return this._sessionContext.isSmallScreen();
    }

// #region filter Estadisticas

    public filterEstadisticas(tipo: string) {
        this.resetForm();

        this.showWarning = true;
        this.mensajes = [];
        this.mensajes.push({ class: 'success', message: 'centralEstadisticas.filters.tipoEstadistica' });

        this.initialStateCampanyas = 'noSelected';
        this.initialStateDenominaciones = 'noSelected';
        this.initialStatePaises = 'noSelected';

        switch (tipo) {
            case 'PD':
                this.filtersVisible = false;
                this.filterPaisDenominacion = true;
                this.filterCampanyaPaisDenominacion = false;
                this.filterEtiquetadores = false;
                this.filterDesignacionesPD = false;
                this.filterDesignacionesCPD = false;
                this.filterCultivos = false;
                this.filterEtiquetadoPD = false;
                this.filterEtiquetadoCPD = false;
                break;
            case 'CampanyaPD':
                this.filtersVisible = false;
                this.filterPaisDenominacion = false;
                this.filterCampanyaPaisDenominacion = true;
                this.filterEtiquetadores = false;
                this.filterDesignacionesPD = false;
                this.filterDesignacionesCPD = false;
                this.filterCultivos = false;
                this.filterEtiquetadoPD = false;
                this.filterEtiquetadoCPD = false;
                break;
        }
    }

    public filterTipo(tipo: string) {
        this.filtersForm.get('etiquetador').reset();
        this.showWarning = true;
        this.mensajes = [];
        this.mensajes.push({ class: 'success', message: 'centralEstadisticas.filters.aplicarFiltro' });

        setTimeout(() => {
            this.initialStateCampanyas = 'allSelected';
            this.initialStateDenominaciones = 'allSelected';
            this.initialStatePaises = 'allSelected';
        }, 100);

        switch (tipo) {
            case 'Etiquetadores':
                this.manageEtiquetadoresFilters();
                break;
            case 'DesignacionesPD':
                this.manageDesignacionesPDFilters();
                break;
            case 'DesignacionesCPD':
                this.manageDesignacionesCPDFilters();
                break;
            case 'Cultivos':
                this.manageCultivosFilters();
                break;
            case 'EtiquetadoPD':
                this.manageEtiquetadoPDFilters();
                break;
            case 'EtiquetadoCPD':
                this.manageEtiquetadoCPDFilters();
                break;
        }
    }

    public manageEtiquetadoresFilters() {
        this.disabledAnyos.next(true);
        this.filtersForm.get('anyoCampanya').disable();

        if (this.paises.length > 1) {
            this.filtersForm.get('pais').enable();
            this.disabledPaises.next(false);
        }
        if (this.denominaciones.length > 1) {
            this.filtersForm.get('denominacion').enable();
            this.disabledDenominaciones.next(false);
        }

        this.filtersForm.get('etiquetador').disable();
        this.disabledEtiquetadores.next(true);
        this.filterEtiquetadores = true;
        this.filterDesignacionesPD = false;
        this.filterDesignacionesCPD = false;
        this.filterCultivos = false;
        this.filterEtiquetadoPD = false;
        this.filterEtiquetadoCPD = false;
        this.filterReetiquetado = false;
        this.filterEtiquetas = false;
        this.filtersVisible = true;
        this.tipoEstadisticas = 1;
    }

    public manageDesignacionesPDFilters() {
        this.disabledAnyos.next(true);
        this.filtersForm.get('anyoCampanya').disable();
        if (this.paises.length > 1) {
            this.filtersForm.get('pais').enable();
            this.disabledPaises.next(false);
        }
        if (this.denominaciones.length > 1) {
            this.filtersForm.get('denominacion').enable();
            this.disabledDenominaciones.next(false);
        }
        this.disabledEtiquetadores.next(true);
        this.filtersForm.get('etiquetador').disable();
        this.filterEtiquetadores = false;
        this.filterDesignacionesPD = true;
        this.filterDesignacionesCPD = false;
        this.filterCultivos = false;
        this.filterEtiquetadoPD = false;
        this.filterEtiquetadoCPD = false;
        this.filterReetiquetado = false;
        this.filterEtiquetas = false;
        this.filtersVisible = true;
        this.tipoEstadisticas = 1;
    }

    public manageDesignacionesCPDFilters() {
        this.disabledAnyos.next(false);
        this.filtersForm.get('anyoCampanya').enable();
        if (this.paises.length > 1) {
            this.filtersForm.get('pais').enable();
            this.disabledPaises.next(false);
        }
        if (this.denominaciones.length > 1) {
            this.filtersForm.get('denominacion').enable();
            this.disabledDenominaciones.next(false);
        }
        this.disabledEtiquetadores.next(true);
        this.filtersForm.get('etiquetador').disable();
        this.filterEtiquetadores = false;
        this.filterDesignacionesPD = false;
        this.filterDesignacionesCPD = true;
        this.filterCultivos = false;
        this.filterEtiquetadoPD = false;
        this.filterEtiquetadoCPD = false;
        this.filterReetiquetado = false;
        this.filterEtiquetas = false;
        this.filtersVisible = true;
        this.tipoEstadisticas = 1;
    }

    public manageCultivosFilters() {
        this.disabledAnyos.next(true);
        this.filtersForm.get('anyoCampanya').disable();
        if (this.paises.length > 1) {
            this.filtersForm.get('pais').enable();
            this.disabledPaises.next(false);
        }
        if (this.denominaciones.length > 1) {
            this.filtersForm.get('denominacion').enable();
            this.disabledDenominaciones.next(false);
        }
        this.disabledEtiquetadores.next(true);
        this.filtersForm.get('etiquetador').disable();
        this.filterEtiquetadores = false;
        this.filterDesignacionesPD = false;
        this.filterDesignacionesCPD = false;
        this.filterCultivos = true;
        this.filterEtiquetadoPD = false;
        this.filterEtiquetadoCPD = false;
        this.filterReetiquetado = false;
        this.filterEtiquetas = false;
        this.filtersVisible = true;
        this.tipoEstadisticas = 1;
    }

    public manageEtiquetadoPDFilters() {
        this.disabledAnyos.next(true);
        this.filtersForm.get('anyoCampanya').disable();
        if (this.paises.length > 1) {
            this.filtersForm.get('pais').enable();
            this.disabledPaises.next(false);
        }
        if (this.denominaciones.length > 1) {
            this.filtersForm.get('denominacion').enable();
            this.disabledDenominaciones.next(false);
        }
        this.disabledEtiquetadores.next(true);
        this.filtersForm.get('etiquetador').disable();
        this.filterEtiquetadores = false;
        this.filterDesignacionesPD = false;
        this.filterDesignacionesCPD = false;
        this.filterCultivos = false;
        this.filterEtiquetadoPD = true;
        this.filterEtiquetadoCPD = false;
        this.filterReetiquetado = false;
        this.filterEtiquetas = false;
        this.filtersVisible = true;
        this.tipoEstadisticas = 1;
    }

    public manageEtiquetadoCPDFilters() {
        this.disabledAnyos.next(false);
        this.filtersForm.get('anyoCampanya').enable();
        if (this.paises.length > 1) {
            this.filtersForm.get('pais').enable();
            this.disabledPaises.next(false);
        }
        if (this.denominaciones.length > 1) {
            this.filtersForm.get('denominacion').enable();
            this.disabledDenominaciones.next(false);
        }
        this.disabledEtiquetadores.next(true);
        this.filtersForm.get('etiquetador').disable();
        this.filterEtiquetadores = false;
        this.filterDesignacionesPD = false;
        this.filterDesignacionesCPD = false;
        this.filterCultivos = false;
        this.filterEtiquetadoPD = false;
        this.filterEtiquetadoCPD = true;
        this.filterReetiquetado = false;
        this.filterEtiquetas = false;
        this.filtersVisible = true;
        this.tipoEstadisticas = 1;
    }

    //#endregion

// #region getDatos de estadisticas
    public getDatosEtiquetadores(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._dataService.getEstadisticasEtiquetador(this.filtrosEtiquetador).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                this.datosEtiquetadores = resp;
                setTimeout(resolve, 1);
            }, (error) => {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                setTimeout(resolve, 1);
            });
        });
    }

    public getDatosDesignaciones(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._dataService.getEstadisticasDesignacion(this.filtrosDesignacion).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                this.datosDesignaciones = resp;
                setTimeout(resolve, 1);
            }, (error) => {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                setTimeout(resolve, 1);
            });
        });
    }

    public getDatosDesignacionesFiltroCompleto(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._dataService.getEstadisticasDesignacionFiltroCompleto(this.filtrosDesignacion).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                this.datosDesignacionesFiltroCompleto = resp;
                setTimeout(resolve, 1);
            }, (error) => {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                setTimeout(resolve, 1);
            });
        });
    }

    public getDatosCultivos(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._dataService.getEstadisticasCultivo(this.filtrosCultivo).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                this.datosCultivos = resp;
                setTimeout(resolve, 1);
            }, (error) => {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                setTimeout(resolve, 1);
            });
        });
    }

    public getDatosEtiquetado(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._dataService.getEstadisticasEtiquetado(this.filtrosEtiquetado).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                this.datosEtiquetado = resp;
                setTimeout(resolve, 1);
            }, (error) => {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                setTimeout(resolve, 1);
            });
        });
    }

    public getDatosEtiquetadoFiltroCompleto(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._dataService.getEstadisticasEtiquetadoFiltroCompleto(this.filtrosEtiquetado).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                this.datosEtiquetadoFiltroCompleto = resp;
                setTimeout(resolve, 1);
            }, (error) => {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                setTimeout(resolve, 1);
            });
        });
    }

    public getDatosEtiquetadoFiltroEtiquetador(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._dataService.getEstadisticasEtiquetadoFiltroEtiquetador(this.filtrosEtiquetado).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                this.datosEtiquetadoFiltroEtiquetador = resp;
                setTimeout(resolve, 1);
            }, (error) => {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                setTimeout(resolve, 1);
            });
        });
    }

    public getDatosEtiquetadoFiltroEtiquetadorCompleto(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._dataService.getEstadisticasEtiquetadoFiltroEtiquetadorCompleto(this.filtrosEtiquetado).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                this.datosEtiquetadoFiltroEtiquetadorCompleto = resp;
                setTimeout(resolve, 1);
            }, (error) => {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                setTimeout(resolve, 1);
            });
        });
    }

    //#endregion

    public checkValuesForm(): boolean {
        return (
            this.filtersForm.get('anyoCampanya').value ||
            (this.filtersForm.get('pais').value && this.filtersForm.get('pais').enabled) ||
            (this.filtersForm.get('denominacion').value && this.filtersForm.get('denominacion').enabled) ||
            this.filtersForm.get('etiquetador').value) ? true : false;
    }

    public resetForm() {
        event.stopPropagation();
        this.filtersForm.reset({
            anyoCampanya: this.filtersForm.get('anyoCampanya').disabled ? this.filtersForm.get('anyoCampanya').value : null,
            pais: this.filtersForm.get('pais').disabled ? this.filtersForm.get('pais').value : null,
            denominacion: this.filtersForm.get('denominacion').disabled ? this.filtersForm.get('denominacion').value : null,
            etiquetador: this.filtersForm.get('etiquetador').disabled ? this.filtersForm.get('etiquetador').value : null,
        });
    }

    public filtrar() {
        if ((this.filtersForm.valid || this.filtersForm.disabled) && this.checkNullValues()) {
          this.filtrado = true;
          this.applyFilters();
        }
        else {
            this.mensajes = [];
            this.showError = true;
            this.mensajes.push({ class: 'warning', message: 'global.info.noSeleccionado' });
        }
    }

    private applyFilters() {
        if (this.filterEtiquetadores) {
            this.filtrosEtiquetador = {
                lsPaisId: this.filtersForm.get('pais').value ?
                            this.filtersForm.get('pais').value.id ?
                                [this.filtersForm.get('pais').value.id] : this.filtersForm.get('pais').value
                            : null,
                lsDenominacionId: this.filtersForm.get('denominacion').value ?
                                    this.filtersForm.get('denominacion').value.id ?
                                        [this.filtersForm.get('denominacion').value.id] : this.filtersForm.get('denominacion').value
                                     : null
            };
            this.graficasEtiquetadores = null;
            const promises: Promise<any>[] = [];
            promises.push(this.getDatosEtiquetadores());

            Promise.all(promises).then(
                () => {
                    this.numEtiquetadoresEtq = this.datosEtiquetadores.numEtiquetadores;
                    this.numAlmacenesEtq = this.datosEtiquetadores.numAlmacenes;
                    this.numPaisesEtq = this.datosEtiquetadores.numPaises;
                    this.numDenominacionesEtq = this.datosEtiquetadores.numDenominaciones;
                    this.agruparInfoEtiquetadores();
                }, (error) => {
                    console.log('Promise rejected with ' + JSON.stringify(error));
                }
            ).catch(e => console.log(e));
        } else if (this.filterDesignacionesPD) {
            this.filtrosDesignacion = {
                lsPaisId: this.filtersForm.get('pais').value ?
                            this.filtersForm.get('pais').value.id ?
                                [this.filtersForm.get('pais').value.id] : this.filtersForm.get('pais').value
                            : null,
                lsDenominacionId: this.filtersForm.get('denominacion').value ?
                                    this.filtersForm.get('denominacion').value.id ?
                                        [this.filtersForm.get('denominacion').value.id] : this.filtersForm.get('denominacion').value
                                     : null,
                etiquetadorId: this.filtersForm.get('etiquetador').value ? this.filtersForm.get('etiquetador').value.id : null
            };

            this.graficasDesignaciones = null;
            this.designacionesKilosCampanyasPaises1 = [];
            this.designacionesKilosCampanyasDenominaciones2 = [];

            const promises: Promise<any>[] = [];
            promises.push(this.getDatosDesignaciones());

            Promise.all(promises).then(
                () => {
                    this.numDesignacionesDsg = this.datosDesignaciones.numDesignaciones;
                    this.numPaisesDsg = this.datosDesignaciones.numPaises;
                    this.numDenominacionesDsg = this.datosDesignaciones.numDenominaciones;
                    this.aforoDsg = this.datosDesignaciones.totalAforo;
                    this.designadosDsg = this.datosDesignaciones.totalCantidad.toFixed(2);
                    this.agruparInfoDesignaciones();
                }, (error) => {
                    console.log('Promise rejected with ' + JSON.stringify(error));
                }
            ).catch(e => console.log(e));
        } else if (this.filterDesignacionesCPD /*&& (this.filtroAnyo || this.filtroPais || this.filtroDenominacion)*/) {
            this.filtrosDesignacion = {
                lsCampanyasDeAnyo: this.filtersForm.get('anyoCampanya').value ? this.filtersForm.get('anyoCampanya').value : null,
                lsPaisId: this.filtersForm.get('pais').value ?
                            this.filtersForm.get('pais').value.id ?
                                [this.filtersForm.get('pais').value.id] : this.filtersForm.get('pais').value
                            : null,
                lsDenominacionId: this.filtersForm.get('denominacion').value ?
                                    this.filtersForm.get('denominacion').value.id ?
                                        [this.filtersForm.get('denominacion').value.id] : this.filtersForm.get('denominacion').value
                                     : null,
                etiquetadorId: this.filtersForm.get('etiquetador').value ? this.filtersForm.get('etiquetador').value.id : null
            };
            this.graficasDesignacionesFiltroCompleto = null;
            this.designacionesDesignacionesEtiquetadoresPaisDenominacionCampanya1 = [];
            this.designacionesKilosEtiquetadoresPaisDenominacionCampanya1 = [];
            this.designacionesKilosPaisPaisKilos2 = [];
            this.designacionesKilosDenominacionDenominacionKilos2 = [];
            const promises: Promise<any>[] = [];
            promises.push(this.getDatosDesignacionesFiltroCompleto());

            Promise.all(promises).then(
                () => {
                    this.numDesignacionesDsg = this.datosDesignacionesFiltroCompleto.numDesignaciones;
                    this.numPaisesDsg = this.datosDesignacionesFiltroCompleto.numPaises;
                    this.numDenominacionesDsg = this.datosDesignacionesFiltroCompleto.numDenominaciones;
                    this.aforoDsg = this.datosDesignacionesFiltroCompleto.totalAforo;
                    this.designadosDsg = this.datosDesignacionesFiltroCompleto.totalCantidad;
                    this.agruparInfoDesignacionesFiltroCompleto();
                }, (error) => {
                    console.log('Promise rejected with ' + JSON.stringify(error));
                }
            ).catch(e => console.log(e));
        } else if (this.filterCultivos) {
            this.filtrosCultivo = {
                lsPaisId: this.filtersForm.get('pais').value ?
                            this.filtersForm.get('pais').value.id ?
                                [this.filtersForm.get('pais').value.id] : this.filtersForm.get('pais').value
                            : null,
                lsDenominacionId: this.filtersForm.get('denominacion').value ?
                                    this.filtersForm.get('denominacion').value.id ?
                                        [this.filtersForm.get('denominacion').value.id] : this.filtersForm.get('denominacion').value
                                     : null,
            };
            this.graficasCultivos = null;
            const promises: Promise<any>[] = [];
            promises.push(this.getDatosCultivos());

            Promise.all(promises).then(
                () => {
                    this.numCultivosCul = this.datosCultivos.numCultivos;
                    this.numPaisesCul = this.datosCultivos.numPaises;
                    this.numDenominacionesCul = this.datosCultivos.numDenominaciones;
                    this.aforoCul = this.datosCultivos.totalAforo;
                    this.superficieCul = this.datosCultivos.totalSuperficie;
                    this.agruparInfoCultivos();
                }, (error) => {
                    console.log('Promise rejected with ' + JSON.stringify(error));
                }
            ).catch(e => console.log(e));
        } else if (this.filterEtiquetadoPD && (this.filtroPais || this.filtroDenominacion) && this.otherFilter === 3) {
            this.filtrosEtiquetado = {
                lsPaisId: this.filtersForm.get('pais').value ?
                            this.filtersForm.get('pais').value.id ?
                                [this.filtersForm.get('pais').value.id] : this.filtersForm.get('pais').value
                            : null,
                lsDenominacionId: this.filtersForm.get('denominacion').value ?
                                    this.filtersForm.get('denominacion').value.id ?
                                        [this.filtersForm.get('denominacion').value.id] : this.filtersForm.get('denominacion').value
                                     : null
            };
            this.graficasEtiquetado = null;
            this.etiquetadoKilosCampanyasPaises1 = [];
            this.etiquetadoKilosCampanyasDenominaciones2 = [];
            this.etiquetadoKilosCampanyasKilosPaisDenominaciones3 = [];

            const promises: Promise<any>[] = [];
            promises.push(this.getDatosEtiquetado());

            Promise.all(promises).then(
                () => {
                    this.totalKilosDesignadosEto = this.datosEtiquetado.totalKilosDesignados;
                    this.totalKilosNetosEto = this.datosEtiquetado.totalKilosNetos;
                    this.totalKilosCampoEto = this.datosEtiquetado.totalKilosCampo;
                    this.totalKilosExpedicionEto = this.datosEtiquetado.totalKilosExpedicion;
                    this.agruparInfoEtiquetado();
                }, (error) => {
                    console.log('Promise rejected with ' + JSON.stringify(error));
                }
            ).catch(e => console.log(e));

        } else if (this.filterEtiquetadoCPD && this.otherFilter === 0) {
            this.filtrosEtiquetado = {
                lsCampanyasDeAnyo: this.filtersForm.get('anyoCampanya').value ? this.filtersForm.get('anyoCampanya').value : null,
                lsPaisId: this.filtersForm.get('pais').value ?
                            this.filtersForm.get('pais').value.id ?
                                [this.filtersForm.get('pais').value.id] : this.filtersForm.get('pais').value
                            : null,
                lsDenominacionId: this.filtersForm.get('denominacion').value ?
                                    this.filtersForm.get('denominacion').value.id ?
                                        [this.filtersForm.get('denominacion').value.id] : this.filtersForm.get('denominacion').value
                                     : null,
                etiquetadorId: this.filtersForm.get('etiquetador').value ? this.filtersForm.get('etiquetador').value.id : null
            };

            this.graficasEtiquetado = null;
            this.etiquetadoKilosPaisPaisKilosAnyoTotales2 = [];
            this.etiquetadoKilosPaisPaisKilosAnyoDenominacion3 = [];
            this.etiquetadoKilosDenominacionDenominacionPaisesAnyoTotales1 = null;
            this.etiquetadoKilosDenominacionDenominacionKilosAnyoTotales2 = [];
            this.etiquetadoKilosDenominacionDenominacionKilosAnyoPais3 = [];
            this.etiquetadoKilosCampanyasEtiquetadoresPaisDenominacion1 = [];
            this.etiquetadoKilosEtiquetadoresAnyoPaisDenominacion1 = [];
            this.etiquetadoKilosCampanyaPaisMesPaisMesTotales1 = [];
            this.etiquetadoKilosCampanyaPaisMesPaisMes2 = [];
            this.etiquetadoKilosCampanyaDenominacionMesDenominacionMesTotales1 = [];
            this.etiquetadoKilosCampanyaDenominacionMesDenominacionMes2 = [];
            this.etiquetadoPeriodoPaisPaisDenominacionAnyoTotales1 = [];
            this.etiquetadoPeriodoPaisPaisAnyoDenominacion2 = [];
            this.etiquetadoPeriodoDenominacionPaisDenominacionAnyoTotales1 = [];
            this.etiquetadoPeriodoDenominacionDenominacionAnyoPais2 = [];
            const promises: Promise<any>[] = [];
            promises.push(this.getDatosEtiquetadoFiltroCompleto());

            Promise.all(promises).then(
                () => {
                    this.totalKilosDesignadosEto = this.datosEtiquetadoFiltroCompleto.totalKilosDesignados;
                    this.totalKilosNetosEto = this.datosEtiquetadoFiltroCompleto.totalKilosNetos;
                    this.totalKilosCampoEto = this.datosEtiquetadoFiltroCompleto.totalKilosCampo;
                    this.totalKilosExpedicionEto = this.datosEtiquetadoFiltroCompleto.totalKilosExpedicion;
                    this.agruparInfoEtiquetadoFiltroCompleto();
                }, (error) => {
                    console.log('Promise rejected with ' + JSON.stringify(error));
                }
            ).catch(e => console.log(e));

        } else if (this.filterEtiquetadoPD && (this.filtroPais || this.filtroDenominacion) && this.otherFilter === 6) {
            this.filtrosEtiquetado = {
                lsPaisId: this.filtersForm.get('pais').value ?
                            this.filtersForm.get('pais').value.id ?
                                [this.filtersForm.get('pais').value.id] : this.filtersForm.get('pais').value
                            : null,
                lsDenominacionId: this.filtersForm.get('denominacion').value ?
                                    this.filtersForm.get('denominacion').value.id ?
                                        [this.filtersForm.get('denominacion').value.id] : this.filtersForm.get('denominacion').value
                                     : null,
                etiquetadorId: this.filtersForm.get('etiquetador').value ? this.filtersForm.get('etiquetador').value.id : null
            };
            this.graficasEtiquetado = null;
            this.etiquetadoKilosCampanyasPaises1 = [];
            this.etiquetadoKilosCampanyasDenominaciones2 = [];
            this.etiquetadoKilosCampanyasKilosPaisDenominaciones3 = [];

            const promises: Promise<any>[] = [];
            promises.push(this.getDatosEtiquetadoFiltroEtiquetador());

            Promise.all(promises).then(
                () => {
                    this.totalKilosDesignadosEto = this.datosEtiquetadoFiltroEtiquetador.totalKilosDesignados;
                    this.totalKilosNetosEto = this.datosEtiquetadoFiltroEtiquetador.totalKilosNetos;
                    this.totalKilosCampoEto = this.datosEtiquetadoFiltroEtiquetador.totalKilosCampo;
                    this.totalKilosExpedicionEto = this.datosEtiquetadoFiltroEtiquetador.totalKilosExpedicion;
                    this.agruparInfoEtiquetadoFiltroEtiquetador();
                }, (error) => {
                    console.log('Promise rejected with ' + JSON.stringify(error));
                }
            ).catch(e => console.log(e));
        }
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
            this._spinnerService.hideSpinner();
        }
    }

// #region Etiquetadores

    public agruparInfoEtiquetadores() {
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        const promises: Promise<any>[] = [];

        promises.push(this.graficaEtiquetadores_EtiquetadoresPais_Paises_1());
        promises.push(this.graficaEtiquetadores_EtiquetadoresPais_PaisDenominaciones_2());
        promises.push(this.graficaEtiquetadores_EtiquetadoresDenominacion_Denominaciones_1());
        promises.push(this.graficaEtiquetadores_EtiquetadoresDenominacion_DenominacionPaises_2());
        promises.push(this.graficaEtiquetadores_EtiquetadoresNumDenominaciones_NumDenominaciones_1());
        promises.push(this.graficaEtiquetadores_EtiquetadoresNumDenominaciones_NumDenominacionPaises_2());
        promises.push(this.graficaEtiquetadores_EtiquetadoresAnyo_Anyos_1());
        promises.push(this.graficaEtiquetadores_EtiquetadoresAnyo_AcumuladoAnyos_1());
        promises.push(this.graficaEtiquetadores_EtiquetadoresAnyo_PaisesAnyo_2());
        promises.push(this.graficaEtiquetadores_EtiquetadoresAnyo_DenominacionesAnyo_3());

        Promise.all(promises).then(
            (values) => {
                this.graficasEtiquetadores = {
                    grafica1: this.etiquetadoresPaisPaises1,
                    grafica2: this.etiquetadoresPaisPaisDenominaciones2,
                    grafica3: this.etiquetadoresDenominacionDenominaciones1,
                    grafica4: this.etiquetadoresPaisDenominacionPaises2,
                    grafica5: this.etiquetadoresNumDenominacionesNumDenominaciones1,
                    grafica6: this.etiquetadoresNumDenominacionesNumDenominacionPaises2,
                    grafica10: this.etiquetadoresAnyoAcumuladoAnyos1,
                    grafica7: this.etiquetadoresAnyoAnyos1,
                    grafica8: this.etiquetadoresAnyoPaisesAnyo2,
                    grafica9: this.etiquetadoresAnyoDenominacionesAnyo3
                };
                this.checkCloseSpinner();
                return true;
            }
        );
    }

    private graficaEtiquetadores_EtiquetadoresPais_Paises_1(): Promise<any> {
        let paisesEtiquetadores = [];
        let numEtiquetadores = [];
        let porcentajeEtiquetadores = [];
        let coloresGrafica = [];
        let valorMaximo = [];
        let horizontal;

        return new Promise((resolve, reject) => {
            coloresGrafica = this.colores.slice(0, this.datosEtiquetadores.etiquetadores_EtiquetadoresPais_Paises_1.lista.length);
            valorMaximo = this.datosEtiquetadores.etiquetadores_EtiquetadoresPais_Paises_1.valorMaximo;
            horizontal = this.getHorizontalBar(this.datosEtiquetadores.etiquetadores_EtiquetadoresPais_Paises_1.lista);
            this.datosEtiquetadores.etiquetadores_EtiquetadoresPais_Paises_1.lista.forEach(element => {
                paisesEtiquetadores.push(element.desPais);
                numEtiquetadores.push(element.numEtiquetadores);
                porcentajeEtiquetadores.push(element.porcentajeEtiquetadores);
            });
            this.etiquetadoresPaisPaises1 = {
                valorMaximo,
                horizontal,
                paises: paisesEtiquetadores,
                numEtiquetadores,
                porcentajeEtiquetadores,
                colores: coloresGrafica
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaEtiquetadores_EtiquetadoresPais_PaisDenominaciones_2(): Promise<any> {
        let etiquetadores = [];
        let porcentajes = [];
        let coloresGrafica = [];
        let series = [];
        let categorias = [];
        let valorMaximo;
        let bigWidthPes;
        let bigWidthEtq;

        return new Promise((resolve, reject) => {
            categorias = this.datosEtiquetadores.etiquetadores_EtiquetadoresPais_PaisDenominaciones_2.lsCategories;
            valorMaximo = this.datosEtiquetadores.etiquetadores_EtiquetadoresPais_PaisDenominaciones_2.valorMaximo;
            series = this.datosEtiquetadores.etiquetadores_EtiquetadoresPais_PaisDenominaciones_2.lsSeries;
            coloresGrafica = this.colores.slice(0, series.length);

            series.forEach(element => {
                etiquetadores.push({
                    name: element.desValor,
                    data: element.lsValores
                });

                if (element.lsPorcentajes) {
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });

                    bigWidthPes = this.getHorizontal(porcentajes);
                } else {
                    porcentajes = null;
                }
            });

            bigWidthEtq = this.getHorizontal(etiquetadores);

            this.etiquetadoresPaisPaisDenominaciones2 = {
                valorMaximo,
                categorias,
                etiquetadores,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaEtiquetadores_EtiquetadoresDenominacion_Denominaciones_1(): Promise<any> {
        let denominacionesEtq = [];
        let numEtq = [];
        let porcentajeEtq = [];
        let coloresGrafica = [];
        let valorMaximo;
        let horizontal;

        return new Promise((resolve, reject) => {
            coloresGrafica = this.colores.slice(0,  this.datosEtiquetadores.etiquetadores_EtiquetadoresDenominacion_Denominaciones_1.lista.length);
            valorMaximo = this.datosEtiquetadores.etiquetadores_EtiquetadoresDenominacion_Denominaciones_1.valorMaximo;
            horizontal = this.getHorizontalBar(this.datosEtiquetadores.etiquetadores_EtiquetadoresDenominacion_Denominaciones_1.lista);
            this.datosEtiquetadores.etiquetadores_EtiquetadoresDenominacion_Denominaciones_1.lista.forEach(element => {
                denominacionesEtq.push(element.desDenominacion);
                numEtq.push(element.numEtiquetadores);
                porcentajeEtq.push(element.porcentajeEtiquetadores);
            });
            this.etiquetadoresDenominacionDenominaciones1 = {
                valorMaximo,
                horizontal,
                denominaciones: denominacionesEtq,
                numEtiquetadores: numEtq,
                porcentajeEtiquetadores: porcentajeEtq,
                colores: coloresGrafica
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaEtiquetadores_EtiquetadoresDenominacion_DenominacionPaises_2(): Promise<any> {
        let etiquetadores = [];
        let porcentajes = [];
        let categorias = [];
        let coloresGrafica = [];
        let valorMaximo;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            categorias = this.datosEtiquetadores.etiquetadores_EtiquetadoresDenominacion_DenominacionPaises_2.lsCategories;
            valorMaximo = this.datosEtiquetadores.etiquetadores_EtiquetadoresDenominacion_DenominacionPaises_2.valorMaximo;
            coloresGrafica = this.colores.slice(0, this.datosEtiquetadores.etiquetadores_EtiquetadoresDenominacion_DenominacionPaises_2.lsSeries.length);

            this.datosEtiquetadores.etiquetadores_EtiquetadoresDenominacion_DenominacionPaises_2.lsSeries.forEach(element => {
                etiquetadores.push({
                    name: element.desValor,
                    data: element.lsValores
                });

                if (element.lsPorcentajes) {
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });

                    bigWidthPes = this.getHorizontal(porcentajes);
                } else {
                    porcentajes = null;
                }

            });

            const bigWidthEtq = this.getHorizontal(etiquetadores);

            this.etiquetadoresPaisDenominacionPaises2 = {
                valorMaximo,
                categorias,
                etiquetadores,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaEtiquetadores_EtiquetadoresNumDenominaciones_NumDenominaciones_1(): Promise<any> {
        let numDeno = [];
        let numEtq = [];
        let porcentajeEtq = [];
        let coloresGrafica = [];
        let valorMaximo;
        let horizontal;


        return new Promise((resolve, reject) => {
            coloresGrafica = this.colores.slice(0,  this.datosEtiquetadores.etiquetadores_EtiquetadoresNumDenominaciones_NumDenominaciones_1.lista.length);
            valorMaximo = this.datosEtiquetadores.etiquetadores_EtiquetadoresNumDenominaciones_NumDenominaciones_1.valorMaximo;
            horizontal = this.getHorizontalBar(this.datosEtiquetadores.etiquetadores_EtiquetadoresNumDenominaciones_NumDenominaciones_1.lista);

            this.datosEtiquetadores.etiquetadores_EtiquetadoresNumDenominaciones_NumDenominaciones_1.lista.forEach(element => {
                numDeno.push(element.strNumDenominaciones);
                numEtq.push(element.numEtiquetadores);
                porcentajeEtq.push(element.porcentajeEtiquetadores);
            });
            this.etiquetadoresNumDenominacionesNumDenominaciones1 = {
                valorMaximo,
                horizontal,
                denominaciones: numDeno,
                numEtiquetadores: numEtq,
                porcentajeEtiquetadores: porcentajeEtq,
                colores: coloresGrafica
            };
            setTimeout(resolve, 1);

        });
    }

    private graficaEtiquetadores_EtiquetadoresNumDenominaciones_NumDenominacionPaises_2(): Promise<any> {
        let etiquetadores = [];
        let porcentajes = [];
        let categorias = [];
        let coloresGrafica = [];
        let valorMaximo;
        let bigWidthPes;
        let bigWidthEtq;

        return new Promise((resolve, reject) => {
            categorias = this.datosEtiquetadores.etiquetadores_EtiquetadoresNumDenominaciones_NumDenominacionPaises_2.lsCategories;
            valorMaximo = this.datosEtiquetadores.etiquetadores_EtiquetadoresNumDenominaciones_NumDenominacionPaises_2.valorMaximo;
            coloresGrafica = this.colores.slice(0, this.datosEtiquetadores.etiquetadores_EtiquetadoresNumDenominaciones_NumDenominacionPaises_2.lsSeries.length);

            this.datosEtiquetadores.etiquetadores_EtiquetadoresNumDenominaciones_NumDenominacionPaises_2.lsSeries.forEach(element => {
                etiquetadores.push({
                    name: element.desValor,
                    data: element.lsValores
                });

                if (element.lsPorcentajes) {
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });

                    bigWidthPes = this.getHorizontal(porcentajes);
                } else {
                    porcentajes = null;
                }
            });

            bigWidthEtq = this.getHorizontal(etiquetadores);

            this.etiquetadoresNumDenominacionesNumDenominacionPaises2 = {
                valorMaximo,
                categorias,
                etiquetadores,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaEtiquetadores_EtiquetadoresAnyo_Anyos_1(): Promise<any> {
        let anyos = [];
        let numEtq = [];
        let porcentajeEtq = [];
        let coloresGrafica = [];
        let valorMaximo;
        let horizontal;


        return new Promise((resolve, reject) => {
            coloresGrafica = this.colores.slice(0,  this.datosEtiquetadores.etiquetadores_EtiquetadoresAnyo_Anyos_1.lista.length);
            valorMaximo = this.datosEtiquetadores.etiquetadores_EtiquetadoresAnyo_Anyos_1.valorMaximo;
            horizontal = this.getHorizontalBar(this.datosEtiquetadores.etiquetadores_EtiquetadoresAnyo_Anyos_1.lista);

            this.datosEtiquetadores.etiquetadores_EtiquetadoresAnyo_Anyos_1.lista.forEach(element => {
                anyos.push(element.strAnyo);
                numEtq.push(element.numEtiquetadores);
                porcentajeEtq.push(element.porcentajeEtiquetadores);
            });
            this.etiquetadoresAnyoAnyos1 = {
                valorMaximo,
                horizontal,
                anyos,
                numEtiquetadores: numEtq,
                porcentajeEtiquetadores: porcentajeEtq,
                colores: coloresGrafica
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaEtiquetadores_EtiquetadoresAnyo_AcumuladoAnyos_1(): Promise<any> {
        let etiquetadores = [];
        let bigWidthPes;
        let categorias = [];
        let coloresGrafica = [];
        let valorMaximo;
        let bigWidthEtq;

        return new Promise((resolve, reject) => {
            categorias = this.datosEtiquetadores.etiquetadores_EtiquetadoresAnyo_AcumuladoAnyos_1.lsCategories;
            valorMaximo = this.datosEtiquetadores.etiquetadores_EtiquetadoresAnyo_AcumuladoAnyos_1.valorMaximo;
            coloresGrafica = this.colores.slice(0, categorias.length);

            this.datosEtiquetadores.etiquetadores_EtiquetadoresAnyo_AcumuladoAnyos_1.lsSeries.forEach(element => {
                etiquetadores.push({
                    name: element.desValor,
                    data: element.lsValores
                });
            });

            bigWidthEtq = this.getHorizontal(etiquetadores);

            this.etiquetadoresAnyoAcumuladoAnyos1 = {
                valorMaximo,
                categorias,
                etiquetadores,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaEtiquetadores_EtiquetadoresAnyo_PaisesAnyo_2(): Promise<any> {
        let etiquetadores = [];
        let porcentajes = [];
        let categorias = [];
        let coloresGrafica = [];
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            categorias = this.datosEtiquetadores.etiquetadores_EtiquetadoresAnyo_PaisesAnyo_2.lsCategories;
            valorMaximo = this.datosEtiquetadores.etiquetadores_EtiquetadoresAnyo_PaisesAnyo_2.valorMaximo;
            coloresGrafica = this.colores.slice(0, this.datosEtiquetadores.etiquetadores_EtiquetadoresAnyo_PaisesAnyo_2.lsSeries.length);

            this.datosEtiquetadores.etiquetadores_EtiquetadoresAnyo_PaisesAnyo_2.lsSeries.forEach(element => {
                etiquetadores.push({
                    name: element.desValor,
                    data: element.lsValores
                });
                if (element.lsPorcentajes) {
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });

                    bigWidthPes = this.getHorizontal(porcentajes);
                } else {
                    porcentajes = null;
                }
            });

            bigWidthEtq = this.getHorizontal(etiquetadores);

            this.etiquetadoresAnyoPaisesAnyo2 = {
                valorMaximo,
                categorias,
                etiquetadores,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaEtiquetadores_EtiquetadoresAnyo_DenominacionesAnyo_3(): Promise<any> {
        let etiquetadores = [];
        let porcentajes = [];
        let categorias = [];
        let series = [];
        let coloresGrafica = [];
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            categorias = this.datosEtiquetadores.etiquetadores_EtiquetadoresAnyo_DenominacionesAnyo_3.lsCategories;
            series = this.datosEtiquetadores.etiquetadores_EtiquetadoresAnyo_DenominacionesAnyo_3.lsSeries;
            valorMaximo = this.datosEtiquetadores.etiquetadores_EtiquetadoresAnyo_DenominacionesAnyo_3.valorMaximo;
            coloresGrafica = this.colores.slice(0, series.length);

            series.forEach(element => {
                etiquetadores.push({
                    name: element.desValor,
                    data: element.lsValores
                });
                if (element.lsPorcentajes) {
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });

                    bigWidthPes = this.getHorizontal(porcentajes);
                } else {
                    porcentajes = null;
                }
            });

            bigWidthEtq = this.getHorizontal(etiquetadores);

            this.etiquetadoresAnyoDenominacionesAnyo3 = {
                valorMaximo,
                categorias,
                etiquetadores,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }
    //#endregion

// #region Designaciones
    public agruparInfoDesignaciones() {
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        let promises: Promise<any>[] = [];

        promises.push(this.graficaDesignaciones_DesignacionesPais_Paises_1());
        promises.push(this.graficaDesignaciones_DesignacionesPais_PaisDenominaciones_2());
        promises.push(this.graficaDesignaciones_DesignacionesDenominacion_Denominaciones_1());
        promises.push(this.graficaDesignaciones_DesignacionesDenominacion_DenominacionPaises_2());
        promises.push(this.graficaDesignaciones_DesignacionesCampanya_Campanyas_1());
        promises.push(this.graficaDesignaciones_DesignacionesCampanya_PaisesCampanya_2());
        promises.push(this.graficaDesignaciones_DesignacionesCampanya_DenominacionesCampanya_3());
        promises.push(this.graficasDesignaciones_KilosCampanyas_Paises_1());
        promises.push(this.graficasDesignaciones_KilosCampanyas_Denominaciones_2());

        Promise.all(promises).then(
            (values) => {
                this.graficasDesignaciones = {
                    grafica1: this.designacionesDesignacionesPaisPaises1,
                    grafica2: this.designacionesDesignacionesPaisPaisDenominaciones2,
                    grafica3: this.designacionesDesignacionesDenominacionDenominaciones1,
                    grafica4: this.designacionesDesignacionesDenominacionDenominacionPaises2,
                    grafica5: this.designacionesDesignacionesCampanyaCampanyas1,
                    grafica6: this.designacionesDesignacionesCampanyaPaisesCampanya2,
                    grafica7: this.designacionesDesignacionesCampanyaDenominacionesCampanya3,
                    graficas8: [this.designacionesKilosCampanyasPaises1, this.designacionesKilosCampanyasDenominaciones2]
                };
                this.checkCloseSpinner();
                return true;
            }
        );
    }

    public agruparInfoDesignacionesFiltroCompleto() {
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        let promises: Promise<any>[] = [];

        promises.push(this.graficasDesignaciones_DesignacionesEtiquetadores_PaisDenominacionCampanya_1());
        promises.push(this.graficasDesignaciones_KilosEtiquetadores_PaisDenominacionCampanya_1());
        promises.push(this.graficaDesignaciones_KilosPais_PaisDenominaciones_1());
        promises.push(this.graficasDesignaciones_KilosPais_PaisKilos_2());
        promises.push(this.graficaDesignaciones_KilosDenominacion_DenominacionPaises_1());
        promises.push(this.graficasDesignaciones_KilosDenominacion_DenominacionKilos_2());

        Promise.all(promises).then(
            (values) => {
                this.graficasDesignacionesFiltroCompleto = {
                    graficasTab4: this.designacionesDesignacionesEtiquetadoresPaisDenominacionCampanya1,
                    graficasTab8: this.designacionesKilosEtiquetadoresPaisDenominacionCampanya1,
                    graficasTab5: [this.designacionesKilosPaisPaisDenominaciones1, this.designacionesKilosPaisPaisKilos2],
                    graficasTab6: [this.designacionesKilosDenominacionDenominacionPaises1, this.designacionesKilosDenominacionDenominacionKilos2]
                };
                this.checkCloseSpinner();
                return true;
            }
        );
    }

    private graficaDesignaciones_DesignacionesPais_Paises_1(): Promise<any> {
        let paisesDesignaciones = [];
        let numDesignaciones = [];
        let porcentajeDesignaciones = [];
        let coloresGrafica = [];
        let valorMaximo;
        let horizontal;

        return new Promise((resolve, reject) => {
            coloresGrafica = this.colores.slice(0, this.datosDesignaciones.designaciones_DesignacionesPais_Paises_1.lista.length);
            valorMaximo = this.datosDesignaciones.designaciones_DesignacionesPais_Paises_1.valorMaximo;
            horizontal = this.getHorizontalBar(this.datosDesignaciones.designaciones_DesignacionesPais_Paises_1.lista);

            this.datosDesignaciones.designaciones_DesignacionesPais_Paises_1.lista.forEach(element => {
                paisesDesignaciones.push(element.desPais);
                numDesignaciones.push(element.numDesignaciones);
                porcentajeDesignaciones.push(element.porcentajeDesignaciones);
            });
            this.designacionesDesignacionesPaisPaises1 = {
                valorMaximo,
                horizontal,
                paises: paisesDesignaciones,
                numDesignaciones,
                porcentajeDesignaciones,
                colores: coloresGrafica
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaDesignaciones_DesignacionesPais_PaisDenominaciones_2(): Promise<any> {
        let designaciones = [];
        let porcentajes = [];
        let coloresGrafica = [];
        let categorias = [];
        let series = [];
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            categorias = this.datosDesignaciones.designaciones_DesignacionesPais_PaisDenominaciones_2.lsCategories;
            series = this.datosDesignaciones.designaciones_DesignacionesPais_PaisDenominaciones_2.lsSeries;
            valorMaximo = this.datosDesignaciones.designaciones_DesignacionesPais_PaisDenominaciones_2.valorMaximo;
            coloresGrafica = this.colores.slice(0, series.length);

            series.forEach(element => {
                designaciones.push({
                    name: element.desValor,
                    data: element.lsValores
                });
                if (element.lsPorcentajes) {
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });

                    bigWidthPes = this.getHorizontal(porcentajes);
                } else {
                    porcentajes = null;
                }
            });

            bigWidthEtq = this.getHorizontal(designaciones);

            this.designacionesDesignacionesPaisPaisDenominaciones2 = {
                valorMaximo,
                categorias,
                designaciones,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaDesignaciones_DesignacionesDenominacion_Denominaciones_1(): Promise<any> {
        let denominacionesDesignaciones = [];
        let numDesignaciones = [];
        let porcentajeDesignaciones = [];
        let coloresGrafica = [];
        let valorMaximo;
        let horizontal;

        return new Promise((resolve, reject) => {
            coloresGrafica = this.colores.slice(0, this.datosDesignaciones.designaciones_DesignacionesDenominacion_Denominaciones_1.lista.length);
            valorMaximo = this.datosDesignaciones.designaciones_DesignacionesDenominacion_Denominaciones_1.valorMaximo;
            horizontal = this.getHorizontalBar(this.datosDesignaciones.designaciones_DesignacionesDenominacion_Denominaciones_1.lista);

            this.datosDesignaciones.designaciones_DesignacionesDenominacion_Denominaciones_1.lista.forEach(element => {
                denominacionesDesignaciones.push(element.desDenominacion);
                numDesignaciones.push(element.numDesignaciones);
                porcentajeDesignaciones.push(element.porcentajeDesignaciones);
            });
            this.designacionesDesignacionesDenominacionDenominaciones1 = {
                valorMaximo,
                horizontal,
                denominaciones: denominacionesDesignaciones,
                numDesignaciones,
                porcentajeDesignaciones,
                colores: coloresGrafica
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaDesignaciones_DesignacionesDenominacion_DenominacionPaises_2(): Promise<any> {
        let designaciones = [];
        let porcentajes = [];
        let categorias = [];
        let coloresGrafica = [];
        let valorMaximo;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            categorias = this.datosDesignaciones.designaciones_DesignacionesDenominacion_DenominacionPaises_2.lsCategories;
            valorMaximo = this.datosDesignaciones.designaciones_DesignacionesDenominacion_DenominacionPaises_2.valorMaximo;
            coloresGrafica = this.colores.slice(0, this.datosDesignaciones.designaciones_DesignacionesDenominacion_DenominacionPaises_2.lsSeries.length);

            this.datosDesignaciones.designaciones_DesignacionesDenominacion_DenominacionPaises_2.lsSeries.forEach(element => {
                designaciones.push({
                    name: element.desValor,
                    data: element.lsValores
                });
                if (element.lsPorcentajes) {
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });

                    bigWidthPes = this.getHorizontal(porcentajes);
                } else {
                    porcentajes = null;
                }
            });

            const bigWidthEtq = this.getHorizontal(designaciones);

            this.designacionesDesignacionesDenominacionDenominacionPaises2 = {
                valorMaximo,
                categorias,
                designaciones,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaDesignaciones_DesignacionesCampanya_Campanyas_1(): Promise<any> {
        let anyos = [];
        let numDesignaciones = [];
        let porcentajeDesignaciones = [];
        let coloresGrafica = [];
        let valorMaximo;
        let horizontal;

        return new Promise((resolve, reject) => {
            coloresGrafica = this.colores.slice(0, this.datosDesignaciones.designaciones_DesignacionesCampanya_Campanyas_1.lista.length);
            valorMaximo = this.datosDesignaciones.designaciones_DesignacionesCampanya_Campanyas_1.valorMaximo;
            horizontal = this.getHorizontalBar(this.datosDesignaciones.designaciones_DesignacionesCampanya_Campanyas_1.lista);

            this.datosDesignaciones.designaciones_DesignacionesCampanya_Campanyas_1.lista.forEach(element => {
                anyos.push(element.strAnyo);
                numDesignaciones.push(element.numero);
                porcentajeDesignaciones.push(element.porcentaje);
            });
            this.designacionesDesignacionesCampanyaCampanyas1 = {
                valorMaximo,
                horizontal,
                anyos,
                numDesignaciones,
                porcentajeDesignaciones,
                colores: coloresGrafica
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaDesignaciones_DesignacionesCampanya_PaisesCampanya_2(): Promise<any> {
        let designaciones = [];
        let porcentajes = [];
        let categorias = [];
        let series = [];
        let coloresGrafica = [];
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            categorias = this.datosDesignaciones.designaciones_DesignacionesCampanya_PaisesCampanya_2.lsCategories;
            series = this.datosDesignaciones.designaciones_DesignacionesCampanya_PaisesCampanya_2.lsSeries;
            valorMaximo = this.datosDesignaciones.designaciones_DesignacionesCampanya_PaisesCampanya_2.valorMaximo;
            coloresGrafica = this.colores.slice(0, series.length);

            series.forEach(element => {
                designaciones.push({
                    name: element.desValor,
                    data: element.lsValores
                });
                if (element.lsPorcentajes) {
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });

                    bigWidthPes = this.getHorizontal(porcentajes);
                } else {
                    porcentajes = null;
                }
            });

            bigWidthEtq = this.getHorizontal(designaciones);

            this.designacionesDesignacionesCampanyaPaisesCampanya2 = {
                valorMaximo,
                categorias,
                designaciones,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaDesignaciones_DesignacionesCampanya_DenominacionesCampanya_3(): Promise<any> {
        let designaciones = [];
        let porcentajes = [];
        let categorias = [];
        let series = [];
        let coloresGrafica = [];
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            categorias = this.datosDesignaciones.designaciones_DesignacionesCampanya_DenominacionesCampanya_3.lsCategories;
            series = this.datosDesignaciones.designaciones_DesignacionesCampanya_DenominacionesCampanya_3.lsSeries;
            valorMaximo = this.datosDesignaciones.designaciones_DesignacionesCampanya_DenominacionesCampanya_3.valorMaximo;
            coloresGrafica = this.colores.slice(0, series.length);

            series.forEach(element => {
                designaciones.push({
                    name: element.desValor,
                    data: element.lsValores
                });
                if (element.lsPorcentajes) {
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });

                    bigWidthPes = this.getHorizontal(porcentajes);
                } else {
                    porcentajes = null;
                }
            });

            bigWidthEtq = this.getHorizontal(designaciones);

            this.designacionesDesignacionesCampanyaDenominacionesCampanya3 = {
                valorMaximo,
                categorias,
                designaciones,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficasDesignaciones_DesignacionesEtiquetadores_PaisDenominacionCampanya_1(): Promise<any> {
        let etiquetadoresDesignaciones = [];
        let numDesignaciones = [];
        let porcentajeDesignaciones = [];

        return new Promise((resolve, reject) => {
            this.datosDesignacionesFiltroCompleto.designaciones_DesignacionesEtiquetadores_PaisDenominacionCampanya_1.forEach(element => {
                etiquetadoresDesignaciones = [];
                numDesignaciones = [];
                porcentajeDesignaciones = [];

                let grafica = {
                    anyo: element.anyo,
                    pais: element.desPais,
                    denominacion: element.desDenominacion,
                    etiquetadores: etiquetadoresDesignaciones,
                    numDesignaciones,
                    porcentajeDesignaciones,
                    valorMaximo: element.lsDsgEtiquetadorCampanya.valorMaximo
                };
                element.lsDsgEtiquetadorCampanya.lista.forEach(element => {
                    etiquetadoresDesignaciones.push(element.desEtiquetador);
                    numDesignaciones.push(element.numDesignaciones);
                    porcentajeDesignaciones.push(element.porcentajeDesignaciones);
                });
                this.designacionesDesignacionesEtiquetadoresPaisDenominacionCampanya1.push(grafica);
            });
            setTimeout(resolve, 1);
        });
    }

    private graficasDesignaciones_KilosEtiquetadores_PaisDenominacionCampanya_1(): Promise<any> {
        let etiquetadoresDesignaciones = [];
        let porcentajeDesignaciones = [];
        let kilosDesignados = [];

        return new Promise((resolve, reject) => {
            this.datosDesignacionesFiltroCompleto.designaciones_KilosEtiquetadores_PaisDenominacionCampanya_1.forEach(element => {
                etiquetadoresDesignaciones = [];
                porcentajeDesignaciones = [];
                kilosDesignados = [];

                let grafica = {
                    anyo: element.anyo,
                    pais: element.desPais,
                    denominacion: element.desDenominacion,
                    etiquetadores: etiquetadoresDesignaciones,
                    porcentajeDesignaciones,
                    kilosDesignados,
                    valorMaximo: element.lsDsgEtiquetadorCampanya.valorMaximo
                };
                element.lsDsgEtiquetadorCampanya.lista.forEach(element => {
                    etiquetadoresDesignaciones.push(element.desEtiquetador);
                    porcentajeDesignaciones.push(element.porcentajeDesignaciones);
                    kilosDesignados.push(element.kilosDesignados);
                });
                this.designacionesKilosEtiquetadoresPaisDenominacionCampanya1.push(grafica);
            });
            setTimeout(resolve, 1);
        });
    }

    private graficaDesignaciones_KilosPais_PaisDenominaciones_1(): Promise<any> {
        let designaciones = [];
        let porcentajes = [];
        let categorias = [];
        let series = [];
        let coloresGrafica = [];
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            categorias = this.datosDesignacionesFiltroCompleto.designaciones_KilosPais_PaisDenominaciones_1.lsCategories;
            series = this.datosDesignacionesFiltroCompleto.designaciones_KilosPais_PaisDenominaciones_1.lsSeries;
            valorMaximo = this.datosDesignacionesFiltroCompleto.designaciones_KilosPais_PaisDenominaciones_1.valorMaximo;
            coloresGrafica = this.coloresSpline.slice(0, series.length);

            series.forEach(element => {
                designaciones.push({
                    name: element.desValor,
                    data: element.lsValores
                });
                if (element.lsPorcentajes) {
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });

                    bigWidthPes = this.getHorizontal(porcentajes);
                } else {
                    porcentajes = null;
                }
            });

            bigWidthEtq = this.getHorizontal(designaciones);

            this.designacionesKilosPaisPaisDenominaciones1 = {
                valorMaximo,
                categorias,
                designaciones,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficasDesignaciones_KilosPais_PaisKilos_2(): Promise<any> {
        let paisesDesignaciones = [];
        let kilosDesignados = [];

        return new Promise((resolve, reject) => {
            this.datosDesignacionesFiltroCompleto.designaciones_KilosPais_PaisKilos_2.forEach(element => {
                paisesDesignaciones = [];
                kilosDesignados = [];
                let grafica = {
                    denominacion: element.desDenominacion,
                    anyo: element.anyo,
                    paises: paisesDesignaciones,
                    kilos: kilosDesignados,
                    valorMaximo: element.lsDenominacionesConKilosByPais.valorMaximo
                };
                element.lsDenominacionesConKilosByPais.lista.filter(x => x.paisId !== -1).forEach(element => {
                    paisesDesignaciones.push(element.desPais);
                    kilosDesignados.push(element.kilos);
                });
                this.designacionesKilosPaisPaisKilos2.push(grafica);
            });
            setTimeout(resolve, 1);
        });
    }

    private graficaDesignaciones_KilosDenominacion_DenominacionPaises_1(): Promise<any> {
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            let designaciones = [];
            let porcentajes = [];
            let categorias = [];
            let coloresGrafica = [];
            categorias = this.datosDesignacionesFiltroCompleto.designaciones_KilosDenominacion_DenominacionPaises_1.lsCategories;
            valorMaximo = this.datosDesignacionesFiltroCompleto.designaciones_KilosDenominacion_DenominacionPaises_1.valorMaximo;
            coloresGrafica = this.coloresSpline.slice(0, categorias.length);

            this.datosDesignacionesFiltroCompleto.designaciones_KilosDenominacion_DenominacionPaises_1.lsSeries.forEach(element => {
                designaciones.push({
                    name: element.desValor,
                    data: element.lsValores
                });
                if (element.lsPorcentajes) {
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });

                    bigWidthPes = this.getHorizontal(porcentajes);
                } else {
                    porcentajes = null;
                }
            });

            bigWidthEtq = this.getHorizontal(designaciones);

            this.designacionesKilosDenominacionDenominacionPaises1 = {
                valorMaximo,
                categorias,
                designaciones,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficasDesignaciones_KilosDenominacion_DenominacionKilos_2(): Promise<any> {
        let denominacionesDesignaciones = [];
        let kilosDesignados = [];

        return new Promise((resolve, reject) => {
            this.datosDesignacionesFiltroCompleto.designaciones_KilosDenominacion_DenominacionKilos_2.forEach(element => {
                denominacionesDesignaciones = [];
                kilosDesignados = [];
                let grafica = {
                    pais: element.desPais,
                    anyo: element.anyo,
                    denominaciones: denominacionesDesignaciones,
                    kilos: kilosDesignados,
                    valorMaximo: element.lsPaisConKilosByDenominacion.valorMaximo
                };
                element.lsPaisConKilosByDenominacion.lista.filter(x => x.denominacionId !== -1).forEach(element => {
                    denominacionesDesignaciones.push(element.desDenominacion);
                    kilosDesignados.push(element.kilos);
                });
                this.designacionesKilosDenominacionDenominacionKilos2.push(grafica);
            });
            setTimeout(resolve, 1);
        });
    }

    private graficasDesignaciones_KilosCampanyas_Paises_1(): Promise<any> {
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            this.datosDesignaciones.designaciones_KilosCampanyas_Paises_1.forEach(element => {
                let designaciones = [];
                let porcentajes = [];
                let categorias = [];
                let coloresGrafica = [];
                categorias = element.dsgByAnyoDeno.lsCategories;
                valorMaximo = element.dsgByAnyoDeno.valorMaximo;
                coloresGrafica = this.colores.slice(0, element.dsgByAnyoDeno.lsSeries.length);

                let grafica = {
                    denominacion: element.desDenominacion,
                    valorMaximo,
                    categorias,
                    designaciones,
                    porcentajes,
                    colores: coloresGrafica,
                    bigWidthEtq,
                    bigWidthPes
                };

                element.dsgByAnyoDeno.lsSeries.forEach(element => {
                    designaciones.push({
                        name: element.desValor,
                        data: element.lsValores
                    });
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });
                });

                bigWidthEtq = this.getHorizontal(designaciones);
                bigWidthPes = this.getHorizontal(porcentajes);

                this.designacionesKilosCampanyasPaises1.push(grafica);
            });
            setTimeout(resolve, 1);
        });
    }

    private graficasDesignaciones_KilosCampanyas_Denominaciones_2(): Promise<any> {
        let valorMaximo;
        let bigWidthPes;
        let bigWidthEtq;

        return new Promise((resolve, reject) => {
            this.datosDesignaciones.designaciones_KilosCampanyas_Denominaciones_2.forEach(element => {
                let designaciones = [];
                let porcentajes = [];
                let categorias = [];
                let coloresGrafica = [];
                categorias = element.numDsgByAnyoPais.lsCategories;
                valorMaximo = element.numDsgByAnyoPais.valorMaximo;
                coloresGrafica = this.colores.slice(0, element.numDsgByAnyoPais.lsSeries.length);

                let grafica = {
                    pais: element.desPais,
                    valorMaximo,
                    categorias,
                    designaciones,
                    porcentajes,
                    colores: coloresGrafica,
                    bigWidthEtq,
                    bigWidthPes
                };

                element.numDsgByAnyoPais.lsSeries.forEach(element => {
                    designaciones.push({
                        name: element.desValor,
                        data: element.lsValores
                    });
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });
                });

                bigWidthEtq = this.getHorizontal(designaciones);
                bigWidthPes = this.getHorizontal(porcentajes);

                this.designacionesKilosCampanyasDenominaciones2.push(grafica);
            });
            setTimeout(resolve, 1);
        });
    }

    //#endregion

// #region Cultivos

    public agruparInfoCultivos() {
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        let promises: Promise<any>[] = [];

        promises.push(this.graficaCultivos_CultivosPais_Paises_1());
        promises.push(this.graficaCultivos_CultivosPais_PaisDenominaciones_2());
        promises.push(this.graficaCultivos_CultivosDenominacion_Denominaciones_1());
        promises.push(this.graficaCultivos_CultivosDenominacion_DenominacionPaises_2());
        promises.push(this.graficaCultivos_CultivosCampanyas_Campanyas_1());
        promises.push(this.graficaCultivos_CultivosCampanyas_PaisesCampanya_2());
        promises.push(this.graficaCultivos_CultivosCampanyas_DenominacionesCampanya_3());
        promises.push(this.graficaCultivos_AforosPais_Paises_1());
        promises.push(this.graficaCultivos_AforosPais_PaisDenominaciones_2());
        promises.push(this.graficaCultivos_AforosDenominacion_Denominaciones_1());
        promises.push(this.graficaCultivos_AforosDenominacion_DenominacionPaises_2());
        promises.push(this.graficaCultivos_AforosCampanyas_Campanyas_1());
        promises.push(this.graficaCultivos_AforosCampanyas_PaisesCampanya_2());
        promises.push(this.graficaCultivos_AforosCampanyas_DenominacionesCampanya_3());
        promises.push(this.graficaCultivos_SuperficiePais_Paises_1());
        promises.push(this.graficaCultivos_SuperficiePais_PaisDenominaciones_2());
        promises.push(this.graficaCultivos_SuperficieDenominacion_Denominaciones_1());
        promises.push(this.graficaCultivos_SuperficieDenominacion_DenominacionPaises_2());
        promises.push(this.graficaCultivos_SuperficieCampanyas_Campanyas_1());
        promises.push(this.graficaCultivos_SuperficieCampanyas_PaisesCampanya_2());
        promises.push(this.graficaCultivos_SuperficieCampanyas_DenominacionesCampanya_3());

        Promise.all(promises).then(
            (values) => {
                this.graficasCultivos = {
                    grafica1: this.cultivosPaisPaises1,
                    grafica2: this.cultivosPaisPaisDenominaciones2,
                    grafica3: this.cultivosDenominacionDenominaciones1,
                    grafica4: this.cultivosDenominacionDenominacionesPaises2,
                    grafica5: this.cultivosCampanyasCampanyas1,
                    grafica6: this.cultivosCampanyasPaisesCampanya2,
                    grafica7: this.cultivosCultivosCampanyasDenominacionesCampanya3,
                    grafica8: this.cultivosAforosPaisPaises1,
                    grafica9: this.cultivosAforosPaisPaisDenominaciones2,
                    grafica10: this.cultivosAforosDenominacionDenominaciones1,
                    grafica11: this.cultivosAforosDenominacionDenominacionPaises2,
                    grafica12: this.cultivosAforosCampanyasCampanyas1,
                    grafica13: this.cultivosAforosCampanyasPaisesCampanya2,
                    grafica14: this.cultivosAforosCampanyasDenominacionesCampanya3,
                    grafica15: this.cultivosSuperficiePaisPaises1,
                    grafica16: this.cultivosSuperficiePaisPaisDenominaciones2,
                    grafica17: this.cultivosSuperficieDenominacionDenominaciones1,
                    grafica18: this.cultivosSuperficieDenominacionDenominacionPaises2,
                    grafica19: this.cultivosSuperficieCampanyasCampanyas1,
                    grafica20: this.cultivosSuperficieCampanyasPaisesCampanya2,
                    grafica21: this.cultivosSuperficieCampanyasDenominacionesCampanya3,
                };
                this.checkCloseSpinner();
                return true;
            }
        );
    }

    private graficaCultivos_CultivosPais_Paises_1(): Promise<any> {
        let paisesCultivos = [];
        let numCultivos = [];
        let porcentajeCultivos = [];
        let coloresGrafica = [];
        let valorMaximo;
        let horizontal;

        return new Promise((resolve, reject) => {
            coloresGrafica = this.colores.slice(0, this.datosCultivos.cultivos_CultivosPais_Paises_1.lista.length);
            valorMaximo = this.datosCultivos.cultivos_CultivosPais_Paises_1.valorMaximo;
            horizontal = this.getHorizontalBar(this.datosCultivos.cultivos_CultivosPais_Paises_1.lista);

            this.datosCultivos.cultivos_CultivosPais_Paises_1.lista.forEach(element => {
                paisesCultivos.push(element.desPais);
                numCultivos.push(element.numCultivos);
                porcentajeCultivos.push(element.porcentajeCultivos);
            });
            this.cultivosPaisPaises1 = {
                valorMaximo,
                horizontal,
                paises: paisesCultivos,
                numCultivos,
                porcentajeCultivos,
                colores: coloresGrafica
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaCultivos_CultivosPais_PaisDenominaciones_2(): Promise<any> {
        let cultivos = [];
        let porcentajes = [];
        let categorias = [];
        let series = [];
        let coloresGrafica = [];
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            categorias = this.datosCultivos.cultivos_CultivosPais_PaisDenominaciones_2.lsCategories;
            series = this.datosCultivos.cultivos_CultivosPais_PaisDenominaciones_2.lsSeries;
            valorMaximo = this.datosCultivos.cultivos_CultivosPais_PaisDenominaciones_2.valorMaximo;
            coloresGrafica = this.colores.slice(0, series.length);

            series.forEach(element => {
                cultivos.push({
                    name: element.desValor,
                    data: element.lsValores
                });
                if (element.lsPorcentajes) {
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });

                    bigWidthPes = this.getHorizontal(porcentajes);
                } else {
                    porcentajes = null;
                }
            });

            bigWidthEtq = this.getHorizontal(cultivos);

            this.cultivosPaisPaisDenominaciones2 = {
                valorMaximo,
                categorias,
                cultivos,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaCultivos_CultivosDenominacion_Denominaciones_1(): Promise<any> {
        let denominacionesCultivos = [];
        let numCultivos = [];
        let porcentajeCultivos = [];
        let coloresGrafica = [];
        let valorMaximo;
        let horizontal;

        return new Promise((resolve, reject) => {
            coloresGrafica = this.colores.slice(0, this.datosCultivos.cultivos_CultivosDenominacion_Denominaciones_1.lista.length);
            valorMaximo = this.datosCultivos.cultivos_CultivosDenominacion_Denominaciones_1.valorMaximo;
            horizontal = this.getHorizontalBar(this.datosCultivos.cultivos_CultivosDenominacion_Denominaciones_1.lista);

            this.datosCultivos.cultivos_CultivosDenominacion_Denominaciones_1.lista.forEach(element => {
                denominacionesCultivos.push(element.desDenominacion);
                numCultivos.push(element.numCultivos);
                porcentajeCultivos.push(element.porcentajeCultivos);
            });
            this.cultivosDenominacionDenominaciones1 = {
                valorMaximo,
                horizontal,
                denominaciones: denominacionesCultivos,
                numCultivos,
                porcentajeCultivos,
                colores: coloresGrafica
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaCultivos_CultivosDenominacion_DenominacionPaises_2(): Promise<any> {
        let cultivos = [];
        let porcentajes = [];
        let categorias = [];
        let series = [];
        let coloresGrafica = [];
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            categorias = this.datosCultivos.cultivos_CultivosDenominacion_DenominacionPaises_2.lsCategories;
            series = this.datosCultivos.cultivos_CultivosDenominacion_DenominacionPaises_2.lsSeries;
            valorMaximo = this.datosCultivos.cultivos_CultivosDenominacion_DenominacionPaises_2.valorMaximo;
            coloresGrafica = this.colores.slice(0, series.length);

            series.forEach(element => {
                cultivos.push({
                    name: element.desValor,
                    data: element.lsValores
                });
                if (element.lsPorcentajes) {
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });

                    bigWidthPes = this.getHorizontal(porcentajes);
                } else {
                    porcentajes = null;
                }
            });

            bigWidthEtq = this.getHorizontal(cultivos);

            this.cultivosDenominacionDenominacionesPaises2 = {
                valorMaximo,
                categorias,
                cultivos,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaCultivos_CultivosCampanyas_Campanyas_1(): Promise<any> {
        let anyos = [];
        let numCultivos = [];
        let porcentajeCultivos = [];
        let coloresGrafica = [];
        let valorMaximo;
        let horizontal;

        return new Promise((resolve, reject) => {
            coloresGrafica = this.colores.slice(0, this.datosCultivos.cultivos_CultivosCampanyas_Campanyas_1.lista.length);
            valorMaximo = this.datosCultivos.cultivos_CultivosCampanyas_Campanyas_1.valorMaximo;
            horizontal = this.getHorizontalBar(this.datosCultivos.cultivos_CultivosCampanyas_Campanyas_1.lista);

            this.datosCultivos.cultivos_CultivosCampanyas_Campanyas_1.lista.forEach(element => {
                anyos.push(element.strAnyo);
                numCultivos.push(element.numCultivos);
                porcentajeCultivos.push(element.porcentajeCultivos);
            });
            this.cultivosCampanyasCampanyas1 = {
                valorMaximo,
                horizontal,
                anyos,
                numCultivos,
                porcentajeCultivos,
                colores: coloresGrafica
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaCultivos_CultivosCampanyas_PaisesCampanya_2(): Promise<any> {
        let cultivos = [];
        let porcentajes = [];
        let categorias = [];
        let series = [];
        let coloresGrafica = [];
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            categorias = this.datosCultivos.cultivos_CultivosCampanyas_PaisesCampanya_2.lsCategories;
            series = this.datosCultivos.cultivos_CultivosCampanyas_PaisesCampanya_2.lsSeries;
            valorMaximo = this.datosCultivos.cultivos_CultivosCampanyas_PaisesCampanya_2.valorMaximo;
            coloresGrafica = this.colores.slice(0, series.length);

            series.forEach(element => {
                cultivos.push({
                    name: element.desValor,
                    data: element.lsValores
                });
                if (element.lsPorcentajes) {
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });

                    bigWidthPes = this.getHorizontal(porcentajes);
                } else {
                    porcentajes = null;
                }
            });

            bigWidthEtq = this.getHorizontal(cultivos);

            this.cultivosCampanyasPaisesCampanya2 = {
                valorMaximo,
                categorias,
                cultivos,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaCultivos_CultivosCampanyas_DenominacionesCampanya_3(): Promise<any> {
        let cultivos = [];
        let porcentajes = [];
        let categorias = [];
        let series = [];
        let coloresGrafica = [];
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            categorias = this.datosCultivos.cultivos_CultivosCampanyas_DenominacionesCampanya_3.lsCategories;
            series = this.datosCultivos.cultivos_CultivosCampanyas_DenominacionesCampanya_3.lsSeries;
            valorMaximo = this.datosCultivos.cultivos_CultivosCampanyas_DenominacionesCampanya_3.valorMaximo;
            coloresGrafica = this.colores.slice(0, series.length);

            series.forEach(element => {
                cultivos.push({
                    name: element.desValor,
                    data: element.lsValores
                });
                if (element.lsPorcentajes) {
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });

                    bigWidthPes = this.getHorizontal(porcentajes);
                } else {
                    porcentajes = null;
                }
            });

            bigWidthEtq = this.getHorizontal(cultivos);

            this.cultivosCultivosCampanyasDenominacionesCampanya3 = {
                valorMaximo,
                categorias,
                cultivos,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaCultivos_AforosPais_Paises_1(): Promise<any> {
        let paises = [];
        let sumAforos = [];
        let porcentajeAforos = [];
        let coloresGrafica = [];
        let valorMaximo;
        let horizontal;

        return new Promise((resolve, reject) => {
            coloresGrafica = this.colores.slice(0, this.datosCultivos.cultivos_AforosPais_Paises_1.lista.length);
            valorMaximo = this.datosCultivos.cultivos_AforosPais_Paises_1.valorMaximo;
            horizontal = this.getHorizontalBar(this.datosCultivos.cultivos_AforosPais_Paises_1.lista);

            this.datosCultivos.cultivos_AforosPais_Paises_1.lista.forEach(element => {
                paises.push(element.desPais);
                sumAforos.push(element.sumAforos);
                porcentajeAforos.push(element.porcentajeAforo);
            });
            this.cultivosAforosPaisPaises1 = {
                valorMaximo,
                horizontal,
                paises,
                sumAforos,
                porcentajeAforos,
                colores: coloresGrafica
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaCultivos_AforosPais_PaisDenominaciones_2(): Promise<any> {
        let cultivos = [];
        let porcentajes = [];
        let categorias = [];
        let series = [];
        let coloresGrafica = [];
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            categorias = this.datosCultivos.cultivos_AforosPais_PaisDenominaciones_2.lsCategories;
            series = this.datosCultivos.cultivos_AforosPais_PaisDenominaciones_2.lsSeries;
            valorMaximo = this.datosCultivos.cultivos_AforosPais_PaisDenominaciones_2.valorMaximo;
            coloresGrafica = this.colores.slice(0, series.length);

            series.forEach(element => {
                cultivos.push({
                    name: element.desValor,
                    data: element.lsValores
                });
                if (element.lsPorcentajes) {
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });

                    bigWidthPes = this.getHorizontal(porcentajes);
                } else {
                    porcentajes = null;
                }
            });

            bigWidthEtq = this.getHorizontal(cultivos);

            this.cultivosAforosPaisPaisDenominaciones2 = {
                valorMaximo,
                categorias,
                cultivos,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaCultivos_AforosDenominacion_Denominaciones_1(): Promise<any> {
        let denominaciones = [];
        let sumAforos = [];
        let porcentajeAforos = [];
        let coloresGrafica = [];
        let valorMaximo;
        let horizontal;

        return new Promise((resolve, reject) => {
            coloresGrafica = this.colores.slice(0, this.datosCultivos.cultivos_AforosDenominacion_Denominaciones_1.lista.length);
            valorMaximo = this.datosCultivos.cultivos_AforosDenominacion_Denominaciones_1.valorMaximo;
            horizontal = this.getHorizontalBar(this.datosCultivos.cultivos_AforosDenominacion_Denominaciones_1.lista);

            this.datosCultivos.cultivos_AforosDenominacion_Denominaciones_1.lista.forEach(element => {
                denominaciones.push(element.desDenominacion);
                sumAforos.push(element.sumAforos);
                porcentajeAforos.push(element.porcentajeAforo);
            });
            this.cultivosAforosDenominacionDenominaciones1 = {
                valorMaximo,
                horizontal,
                denominaciones,
                sumAforos,
                porcentajeAforos,
                colores: coloresGrafica
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaCultivos_AforosDenominacion_DenominacionPaises_2(): Promise<any> {
        let cultivos = [];
        let porcentajes = [];
        let categorias = [];
        let series = [];
        let coloresGrafica = [];
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            categorias = this.datosCultivos.cultivos_AforosDenominacion_DenominacionPaises_2.lsCategories;
            series = this.datosCultivos.cultivos_AforosDenominacion_DenominacionPaises_2.lsSeries;
            valorMaximo = this.datosCultivos.cultivos_AforosDenominacion_DenominacionPaises_2.valorMaximo;
            coloresGrafica = this.colores.slice(0, series.length);

            series.forEach(element => {
                cultivos.push({
                    name: element.desValor,
                    data: element.lsValores
                });
                if (element.lsPorcentajes) {
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });

                    bigWidthPes = this.getHorizontal(porcentajes);
                } else {
                    porcentajes = null;
                }
            });

            bigWidthEtq = this.getHorizontal(cultivos);

            this.cultivosAforosDenominacionDenominacionPaises2 = {
                valorMaximo,
                categorias,
                cultivos,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaCultivos_AforosCampanyas_Campanyas_1(): Promise<any> {
        let anyos = [];
        let sumAforos = [];
        let porcentajeAforos = [];
        let coloresGrafica = [];
        let valorMaximo;
        let horizontal;

        return new Promise((resolve, reject) => {
            coloresGrafica = this.colores.slice(0, this.datosCultivos.cultivos_AforosCampanyas_Campanyas_1.lista.length);
            valorMaximo = this.datosCultivos.cultivos_AforosCampanyas_Campanyas_1.valorMaximo;
            horizontal = this.getHorizontalBar(this.datosCultivos.cultivos_AforosCampanyas_Campanyas_1.lista);

            this.datosCultivos.cultivos_AforosCampanyas_Campanyas_1.lista.forEach(element => {
                anyos.push(element.strAnyo);
                sumAforos.push(element.sumAforos);
                porcentajeAforos.push(element.porcentajeAforo);
            });
            this.cultivosAforosCampanyasCampanyas1 = {
                valorMaximo,
                horizontal,
                anyos,
                sumAforos,
                porcentajeAforos,
                colores: coloresGrafica
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaCultivos_AforosCampanyas_PaisesCampanya_2(): Promise<any> {
        let cultivos = [];
        let porcentajes = [];
        let categorias = [];
        let series = [];
        let coloresGrafica = [];
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            categorias = this.datosCultivos.cultivos_AforosCampanyas_PaisesCampanya_2.lsCategories;
            series = this.datosCultivos.cultivos_AforosCampanyas_PaisesCampanya_2.lsSeries;
            valorMaximo = this.datosCultivos.cultivos_AforosCampanyas_PaisesCampanya_2.valorMaximo;
            coloresGrafica = this.colores.slice(0, series.length);

            series.forEach(element => {
                cultivos.push({
                    name: element.desValor,
                    data: element.lsValores
                });
                if (element.lsPorcentajes) {
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });

                    bigWidthPes = this.getHorizontal(porcentajes);
                } else {
                    porcentajes = null;
                }
            });

            bigWidthEtq = this.getHorizontal(cultivos);

            this.cultivosAforosCampanyasPaisesCampanya2 = {
                valorMaximo,
                categorias,
                cultivos,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaCultivos_AforosCampanyas_DenominacionesCampanya_3(): Promise<any> {
        let cultivos = [];
        let porcentajes = [];
        let categorias = [];
        let series = [];
        let coloresGrafica = [];
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            categorias = this.datosCultivos.cultivos_AforosCampanyas_DenominacionesCampanya_3.lsCategories;
            series = this.datosCultivos.cultivos_AforosCampanyas_DenominacionesCampanya_3.lsSeries;
            valorMaximo = this.datosCultivos.cultivos_AforosCampanyas_DenominacionesCampanya_3.valorMaximo;
            coloresGrafica = this.colores.slice(0, series.length);

            series.forEach(element => {
                cultivos.push({
                    name: element.desValor,
                    data: element.lsValores
                });
                if (element.lsPorcentajes) {
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });

                    bigWidthPes = this.getHorizontal(porcentajes);
                } else {
                    porcentajes = null;
                }
            });

            bigWidthEtq = this.getHorizontal(cultivos);

            this.cultivosAforosCampanyasDenominacionesCampanya3 = {
                valorMaximo,
                categorias,
                cultivos,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaCultivos_SuperficiePais_Paises_1(): Promise<any> {
        let paises = [];
        let sumSuperificies = [];
        let porcentajeSuperficies = [];
        let coloresGrafica = [];
        let valorMaximo;
        let horizontal;

        return new Promise((resolve, reject) => {
            coloresGrafica = this.colores.slice(0, this.datosCultivos.cultivos_SuperficiePais_Paises_1.lista.length);
            valorMaximo = this.datosCultivos.cultivos_SuperficiePais_Paises_1.valorMaximo;
            horizontal = this.getHorizontalBar(this.datosCultivos.cultivos_SuperficiePais_Paises_1.lista);

            this.datosCultivos.cultivos_SuperficiePais_Paises_1.lista.forEach(element => {
                paises.push(element.desPais);
                sumSuperificies.push(element.sumSuperficies);
                porcentajeSuperficies.push(element.porcentajeSuperficie);
            });
            this.cultivosSuperficiePaisPaises1 = {
                valorMaximo,
                horizontal,
                paises,
                sumSuperificies,
                porcentajeSuperficies,
                colores: coloresGrafica
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaCultivos_SuperficiePais_PaisDenominaciones_2(): Promise<any> {
        let cultivos = [];
        let porcentajes = [];
        let categorias = [];
        let series = [];
        let coloresGrafica = [];
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            categorias = this.datosCultivos.cultivos_SuperficiePais_PaisDenominaciones_2.lsCategories;
            series = this.datosCultivos.cultivos_SuperficiePais_PaisDenominaciones_2.lsSeries;
            valorMaximo = this.datosCultivos.cultivos_SuperficiePais_PaisDenominaciones_2.valorMaximo;
            coloresGrafica = this.colores.slice(0, series.length);

            series.forEach(element => {
                cultivos.push({
                    name: element.desValor,
                    data: element.lsValores
                });
                if (element.lsPorcentajes) {
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });

                    bigWidthPes = this.getHorizontal(porcentajes);
                } else {
                    porcentajes = null;
                }
            });

            bigWidthEtq = this.getHorizontal(cultivos);

            this.cultivosSuperficiePaisPaisDenominaciones2 = {
                valorMaximo,
                categorias,
                cultivos,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaCultivos_SuperficieDenominacion_Denominaciones_1(): Promise<any> {
        let denominaciones = [];
        let sumSuperificies = [];
        let porcentajeSuperficies = [];
        let coloresGrafica = [];
        let valorMaximo;
        let horizontal;

        return new Promise((resolve, reject) => {
            coloresGrafica = this.colores.slice(0, this.datosCultivos.cultivos_SuperficieDenominacion_Denominaciones_1.lista.length);
            valorMaximo = this.datosCultivos.cultivos_SuperficieDenominacion_Denominaciones_1.valorMaximo;
            horizontal = this.getHorizontalBar(this.datosCultivos.cultivos_SuperficieDenominacion_Denominaciones_1.lista);

            this.datosCultivos.cultivos_SuperficieDenominacion_Denominaciones_1.lista.forEach(element => {
                denominaciones.push(element.desDenominacion);
                sumSuperificies.push(element.sumSuperficies);
                porcentajeSuperficies.push(element.porcentajeSuperficie);
            });
            this.cultivosSuperficieDenominacionDenominaciones1 = {
                valorMaximo,
                horizontal,
                denominaciones,
                sumSuperificies,
                porcentajeSuperficies,
                colores: coloresGrafica
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaCultivos_SuperficieDenominacion_DenominacionPaises_2(): Promise<any> {
        let cultivos = [];
        let porcentajes = [];
        let categorias = [];
        let series = [];
        let coloresGrafica = [];
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            categorias = this.datosCultivos.cultivos_SuperficieDenominacion_DenominacionPaises_2.lsCategories;
            series = this.datosCultivos.cultivos_SuperficieDenominacion_DenominacionPaises_2.lsSeries;
            valorMaximo = this.datosCultivos.cultivos_SuperficieDenominacion_DenominacionPaises_2.valorMaximo;
            coloresGrafica = this.colores.slice(0, series.length);

            series.forEach(element => {
                cultivos.push({
                    name: element.desValor,
                    data: element.lsValores
                });
                if (element.lsPorcentajes) {
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });

                    bigWidthPes = this.getHorizontal(porcentajes);
                } else {
                    porcentajes = null;
                }
            });

            bigWidthEtq = this.getHorizontal(cultivos);

            this.cultivosSuperficieDenominacionDenominacionPaises2 = {
                valorMaximo,
                categorias,
                cultivos,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaCultivos_SuperficieCampanyas_Campanyas_1(): Promise<any> {
        let anyos = [];
        let sumSuperificies = [];
        let porcentajeSuperficies = [];
        let coloresGrafica = [];
        let valorMaximo;
        let horizontal;

        return new Promise((resolve, reject) => {
            coloresGrafica = this.colores.slice(0, this.datosCultivos.cultivos_SuperficieCampanyas_Campanyas_1.lista.length);
            valorMaximo = this.datosCultivos.cultivos_SuperficieCampanyas_Campanyas_1.valorMaximo;
            horizontal = this.getHorizontalBar(this.datosCultivos.cultivos_SuperficieCampanyas_Campanyas_1.lista);

            this.datosCultivos.cultivos_SuperficieCampanyas_Campanyas_1.lista.forEach(element => {
                anyos.push(element.strAnyo);
                sumSuperificies.push(element.sumSuperficies);
                porcentajeSuperficies.push(element.porcentajeSuperficie);
            });
            this.cultivosSuperficieCampanyasCampanyas1 = {
                valorMaximo,
                horizontal,
                anyos,
                sumSuperificies,
                porcentajeSuperficies,
                colores: coloresGrafica
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaCultivos_SuperficieCampanyas_PaisesCampanya_2(): Promise<any> {
        let cultivos = [];
        let porcentajes = [];
        let categorias = [];
        let series = [];
        let coloresGrafica = [];
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            categorias = this.datosCultivos.cultivos_SuperficieCampanyas_PaisesCampanya_2.lsCategories;
            series = this.datosCultivos.cultivos_SuperficieCampanyas_PaisesCampanya_2.lsSeries;
            valorMaximo = this.datosCultivos.cultivos_SuperficieCampanyas_PaisesCampanya_2.valorMaximo;
            coloresGrafica = this.colores.slice(0, series.length);

            series.forEach(element => {
                cultivos.push({
                    name: element.desValor,
                    data: element.lsValores
                });
                if (element.lsPorcentajes) {
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });

                    bigWidthPes = this.getHorizontal(porcentajes);
                } else {
                    porcentajes = null;
                }
            });

            bigWidthEtq = this.getHorizontal(cultivos);

            this.cultivosSuperficieCampanyasPaisesCampanya2 = {
                valorMaximo,
                categorias,
                cultivos,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficaCultivos_SuperficieCampanyas_DenominacionesCampanya_3(): Promise<any> {
        let cultivos = [];
        let porcentajes = [];
        let categorias = [];
        let series = [];
        let coloresGrafica = [];
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            categorias = this.datosCultivos.cultivos_SuperficieCampanyas_DenominacionesCampanya_3.lsCategories;
            series = this.datosCultivos.cultivos_SuperficieCampanyas_DenominacionesCampanya_3.lsSeries;
            valorMaximo = this.datosCultivos.cultivos_SuperficieCampanyas_DenominacionesCampanya_3.valorMaximo;
            coloresGrafica = this.colores.slice(0, series.length);

            series.forEach(element => {
                cultivos.push({
                    name: element.desValor,
                    data: element.lsValores
                });
                if (element.lsPorcentajes) {
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });

                    bigWidthPes = this.getHorizontal(porcentajes);
                } else {
                    porcentajes = null;
                }
            });

            bigWidthEtq = this.getHorizontal(cultivos);

            this.cultivosSuperficieCampanyasDenominacionesCampanya3 = {
                valorMaximo,
                categorias,
                cultivos,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

//#endregion

//#region Etiquetado

    public agruparInfoEtiquetado() {
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        let promises: Promise<any>[] = [];

        promises.push(this.graficasEtiquetado_KilosCampanyas_Paises_1());
        promises.push(this.graficasEtiquetado_KilosCampanyas_Denominaciones_2());
        promises.push(this.graficasEtiquetado_KilosCampanyas_KilosPaisDenominaciones_3());

        Promise.all(promises).then(
            (values) => {
                this.graficasEtiquetado = {
                    graficasPais: this.etiquetadoKilosCampanyasPaises1,
                    graficasDenominacion: this.etiquetadoKilosCampanyasDenominaciones2,
                    graficasKilos: this.etiquetadoKilosCampanyasKilosPaisDenominaciones3
                };
                this.checkCloseSpinner();
                return true;
            }
        );
    }

    public agruparInfoEtiquetadoFiltroCompleto() {
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        let promises: Promise<any>[] = [];

        promises.push(this.graficasEtiquetado_KilosPais_PaisDenominaciones_AnyoTotales_1());
        promises.push(this.graficasEtiquetado_KilosPais_PaisKilos_AnyoTotales_2());
        promises.push(this.graficasEtiquetado_KilosPais_PaisKilos_AnyoDenominacion_3());
        promises.push(this.graficasEtiquetado_KilosDenominacion_DenominacionPaises_AnyoTotales_1());
        promises.push(this.graficasEtiquetado_KilosDenominacion_DenominacionKilos_AnyoTotales_2());
        promises.push(this.graficasEtiquetado_KilosDenominacion_DenominacionKilos_AnyoPais_3());
        promises.push(this.graficasEtiquetado_KilosCampanyasEtiquetadores_PaisDenominacion_1());
        promises.push(this.graficasEtiquetado_KilosEtiquetadores_AnyoPaisDenominacion_1());

        Promise.all(promises).then(
            (values) => {
                this.graficasEtiquetadoFiltroCompleto = {
                    graficasTab1: [
                        this.etiquetadoKilosPaisPaisDenominacionesAnyoTotales1,
                        this.etiquetadoKilosPaisPaisKilosAnyoTotales2,
                        this.etiquetadoKilosPaisPaisKilosAnyoDenominacion3
                    ],
                    graficasTab2: [
                        this.etiquetadoKilosDenominacionDenominacionPaisesAnyoTotales1,
                        this.etiquetadoKilosDenominacionDenominacionKilosAnyoTotales2,
                        this.etiquetadoKilosDenominacionDenominacionKilosAnyoPais3
                    ],
                    graficasTab4: this.etiquetadoKilosCampanyasEtiquetadoresPaisDenominacion1,
                    graficasTab5: this.etiquetadoKilosEtiquetadoresAnyoPaisDenominacion1
                };
                this.checkCloseSpinner();
                return true;
            }
        );
    }

    public agruparInfoEtiquetadoFiltroEtiquetador() {
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;

        this.etiquetadoKilosEtiquetadorCampanyasDenominaciones1 = [];
        this.etiquetadoKilosEtiquetadorCampanyasKilosDenominaciones2 = [];
        let promises: Promise<any>[] = [];

        promises.push(this.graficasEtiquetado_KilosEtiquetadorCampanyas_Denominaciones_1());
        promises.push(this.graficasEtiquetado_KilosEtiquetadorCampanyas_KilosDenominaciones_2());

        Promise.all(promises).then(
            (values) => {
                this.graficasEtiquetado = {
                    graficasDenominaciones: this.etiquetadoKilosEtiquetadorCampanyasDenominaciones1,
                    graficasDenominacionKilos: this.etiquetadoKilosEtiquetadorCampanyasKilosDenominaciones2
                };
                this.checkCloseSpinner();
                return true;
            }
        );
    }

    private graficasEtiquetado_KilosPais_PaisDenominaciones_AnyoTotales_1(): Promise<any> {
        let etiquetado = [];
        let porcentajes = [];
        let categorias = [];
        let coloresGrafica = [];
        let valorMaximo;
        let bigWidthEtq = false;
        let bigWidthPes = false;

        return new Promise((resolve, reject) => {
            categorias = this.datosEtiquetadoFiltroCompleto.etiquetado_KilosPais_PaisDenominaciones_AnyoTotales_1.length > 0 ?
                         this.datosEtiquetadoFiltroCompleto.etiquetado_KilosPais_PaisDenominaciones_AnyoTotales_1[0].barChart.lsCategories : [];
            valorMaximo = this.datosEtiquetadoFiltroCompleto.etiquetado_KilosPais_PaisDenominaciones_AnyoTotales_1.length > 0 ?
                          this.datosEtiquetadoFiltroCompleto.etiquetado_KilosPais_PaisDenominaciones_AnyoTotales_1[0].barChart.valorMaximo : 0;
            coloresGrafica = categorias.length > 0 ? this.colores.slice(0, categorias.length) : [];

            if (this.datosEtiquetadoFiltroCompleto.etiquetado_KilosPais_PaisDenominaciones_AnyoTotales_1.length > 0) {
                this.datosEtiquetadoFiltroCompleto.etiquetado_KilosPais_PaisDenominaciones_AnyoTotales_1[0].barChart.lsSeries.forEach(element => {
                    etiquetado.push({
                        name: element.desValor,
                        data: element.lsValores
                    });
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });
                });

                bigWidthEtq = this.getHorizontal(etiquetado);
                bigWidthPes = this.getHorizontal(porcentajes);
            }

            this.etiquetadoKilosPaisPaisDenominacionesAnyoTotales1 = {
                valorMaximo,
                categorias,
                etiquetado,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficasEtiquetado_KilosPais_PaisKilos_AnyoTotales_2(): Promise<any> {
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            this.datosEtiquetadoFiltroCompleto.etiquetado_KilosPais_PaisKilos_AnyoTotales_2.forEach(element => {
                let etiquetado = [];
                let porcentajes = [];
                let categorias = [];
                let coloresGrafica = [];
                categorias = element.barChart.lsCategories;
                valorMaximo = element.barChart.valorMaximo;
                coloresGrafica = this.coloresSpline.slice(0, 2);

                element.barChart.lsSeries.forEach(element => {
                    etiquetado.push({
                        name: element.desValor,
                        data: element.lsValores
                    });
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });
                });

                bigWidthEtq = this.getHorizontal(etiquetado);
                bigWidthPes = this.getHorizontal(porcentajes);

                let grafica = {
                    anyo: element.anyo,
                    paisId: this.filtersForm.get('pais').value,
                    desPais: categorias,
                    denominacionId: this.filtersForm.get('denominacion').value,
                    service: 'getRepKilosPaisExcelOrCsv',
                    serviceGrid: 'getEstGridKilosPais',
                    valorMaximo,
                    categorias,
                    etiquetado,
                    porcentajes,
                    colores: coloresGrafica,
                    bigWidthEtq,
                    bigWidthPes
                };

                this.etiquetadoKilosPaisPaisKilosAnyoTotales2.push(grafica);
            });
            setTimeout(resolve, 1);
        });
    }

    private graficasEtiquetado_KilosPais_PaisKilos_AnyoDenominacion_3(): Promise<any> {
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            this.datosEtiquetadoFiltroCompleto.etiquetado_KilosPais_PaisKilos_AnyoDenominacion_3.forEach(element => {
                let etiquetado = [];
                let porcentajes = [];
                let categorias = [];
                let coloresGrafica = [];
                categorias = element.barChart.lsCategories;
                valorMaximo = element.barChart.valorMaximo;
                coloresGrafica = this.coloresSpline.slice(0, 2);

                element.barChart.lsSeries.forEach(element => {
                    etiquetado.push({
                        name: element.desValor,
                        data: element.lsValores
                    });
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });
                });

                bigWidthEtq = this.getHorizontal(etiquetado);
                bigWidthPes = this.getHorizontal(porcentajes);

                let grafica = {
                    anyo: element.anyo,
                    denominacion: element.desDenominacion,
                    denominacionId: [element.denominacionId],
                    paisId: this.filtersForm.get('pais').value,
                    service: 'getRepKilosPaisDenoExcelOrCsv',
                    serviceGrid: 'getEstGridKilosPaisDeno',
                    valorMaximo,
                    categorias,
                    etiquetado,
                    porcentajes,
                    colores: coloresGrafica,
                    bigWidthEtq,
                    bigWidthPes
                };

                this.etiquetadoKilosPaisPaisKilosAnyoDenominacion3.push(grafica);
            });
            setTimeout(resolve, 1);
        });
    }

    private graficasEtiquetado_KilosDenominacion_DenominacionPaises_AnyoTotales_1(): Promise<any> {
        let valorMaximo;
        let bigWidthEtq = false;
        let bigWidthPes = false;

        return new Promise((resolve, reject) => {
            let etiquetado = [];
            let porcentajes = [];
            let categorias = [];
            let coloresGrafica = [];
            categorias = this.datosEtiquetadoFiltroCompleto.etiquetado_KilosDenominacion_DenominacionPaises_AnyoTotales_1.length > 0 ?
                         this.datosEtiquetadoFiltroCompleto.etiquetado_KilosDenominacion_DenominacionPaises_AnyoTotales_1[0].barChart.lsCategories : [];
            valorMaximo = this.datosEtiquetadoFiltroCompleto.etiquetado_KilosDenominacion_DenominacionPaises_AnyoTotales_1.length > 0 ?
                          this.datosEtiquetadoFiltroCompleto.etiquetado_KilosDenominacion_DenominacionPaises_AnyoTotales_1[0].barChart.valorMaximo : 0;
            coloresGrafica = categorias.length > 0 ? this.colores.slice(0, categorias.length) : [];

            if (this.datosEtiquetadoFiltroCompleto.etiquetado_KilosDenominacion_DenominacionPaises_AnyoTotales_1.length > 0) {
                this.datosEtiquetadoFiltroCompleto.etiquetado_KilosDenominacion_DenominacionPaises_AnyoTotales_1[0].barChart.lsSeries.forEach(element => {
                    etiquetado.push({
                        name: element.desValor,
                        data: element.lsValores
                    });
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });
                });

                bigWidthEtq = this.getHorizontal(etiquetado);
                bigWidthPes = this.getHorizontal(porcentajes);
            }

            this.etiquetadoKilosDenominacionDenominacionPaisesAnyoTotales1 = {
                valorMaximo,
                categorias,
                etiquetado,
                porcentajes,
                colores: coloresGrafica,
                bigWidthEtq,
                bigWidthPes
            };
            setTimeout(resolve, 1);
        });
    }

    private graficasEtiquetado_KilosDenominacion_DenominacionKilos_AnyoTotales_2(): Promise<any> {
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            this.datosEtiquetadoFiltroCompleto.etiquetado_KilosDenominacion_DenominacionKilos_AnyoTotales_2.forEach(element => {
                let etiquetado = [];
                let porcentajes = [];
                let categorias = [];
                let coloresGrafica = [];
                categorias = element.barChart.lsCategories;
                valorMaximo = element.barChart.valorMaximo;
                coloresGrafica = this.coloresSpline.slice(0, 2);

                element.barChart.lsSeries.forEach(element => {
                    etiquetado.push({
                        name: element.desValor,
                        data: element.lsValores
                    });
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });
                });

                bigWidthEtq = this.getHorizontal(etiquetado);
                bigWidthPes = this.getHorizontal(porcentajes);

                let grafica = {
                    anyo: element.anyo,
                    paisId: this.filtersForm.get('pais').value,
                    denominacionId: this.filtersForm.get('denominacion').value,
                    service: 'getRepKilosDenoExcelOrCsv',
                    serviceGrid: 'getEstGridKilosDeno',
                    valorMaximo,
                    categorias,
                    etiquetado,
                    porcentajes,
                    colores: coloresGrafica,
                    bigWidthEtq,
                    bigWidthPes
                };

                this.etiquetadoKilosDenominacionDenominacionKilosAnyoTotales2.push(grafica);
            });
            setTimeout(resolve, 1);
        });
    }

    private graficasEtiquetado_KilosDenominacion_DenominacionKilos_AnyoPais_3(): Promise<any> {
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            this.datosEtiquetadoFiltroCompleto.etiquetado_KilosDenominacion_DenominacionKilos_AnyoPais_3.forEach(element => {
                let etiquetado = [];
                let porcentajes = [];
                let categorias = [];
                let coloresGrafica = [];
                categorias = element.barChart.lsCategories;
                valorMaximo = element.barChart.valorMaximo;
                coloresGrafica = this.coloresSpline.slice(0, 2);

                element.barChart.lsSeries.forEach(element => {
                    etiquetado.push({
                        name: element.desValor,
                        data: element.lsValores
                    });
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });
                });

                bigWidthEtq = this.getHorizontal(etiquetado);
                bigWidthPes = this.getHorizontal(porcentajes);

                let grafica = {
                    anyo: element.anyo,
                    pais: element.desPais,
                    paisId: [element.paisId],
                    dneominacionId: this.filtersForm.get('denominacion').value,
                    service: 'getRepKilosDenoPaisExcelOrCsv',
                    serviceGrid: 'getEstGridKilosDenoPais',
                    valorMaximo,
                    categorias,
                    etiquetado,
                    porcentajes,
                    colores: coloresGrafica,
                    bigWidthEtq,
                    bigWidthPes
                };


                this.etiquetadoKilosDenominacionDenominacionKilosAnyoPais3.push(grafica);
            });
            setTimeout(resolve, 1);
        });
    }

    private graficasEtiquetado_KilosCampanyas_Paises_1(): Promise<any> {
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            this.datosEtiquetado.etiquetado_KilosCampanyas_Paises_1.forEach(element => {
                let etiquetado = [];
                let porcentajes = [];
                let categorias = [];
                let coloresGrafica = [];
                categorias = element.barChart.lsCategories;
                valorMaximo = element.barChart.valorMaximo;
                coloresGrafica = this.colores.slice(0, categorias.length);

                element.barChart.lsSeries.forEach(element => {
                    etiquetado.push({
                        name: element.desValor,
                        data: element.lsValores
                    });
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });
                });

                bigWidthEtq = this.getHorizontal(etiquetado);
                bigWidthPes = this.getHorizontal(porcentajes);

                let grafica = {
                    paisId: this.filtersForm.get('pais').value,
                    denominacionId: element.denominacionId ? [element.denominacionId] : this.filtersForm.get('denominacion').value,
                    denominacion: element.desDenominacion,
                    service: 'getRepKilosCampanyasPaisesExcelOrCsv',
                    serviceGrid: 'getEstGridKilosCampanyasPaises',
                    valorMaximo,
                    categorias,
                    etiquetado,
                    porcentajes,
                    colores: coloresGrafica,
                    bigWidthEtq,
                    bigWidthPes
                };

                this.etiquetadoKilosCampanyasPaises1.push(grafica);
            });
            setTimeout(resolve, 1);
        });
    }

    private graficasEtiquetado_KilosCampanyas_Denominaciones_2(): Promise<any> {
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            this.datosEtiquetado.etiquetado_KilosCampanyas_Denominaciones_2.forEach(element => {
                let etiquetado = [];
                let porcentajes = [];
                let categorias = [];
                let coloresGrafica = [];
                categorias = element.barChart.lsCategories;
                valorMaximo = element.barChart.valorMaximo;
                coloresGrafica = this.colores.slice(0, categorias.length);

                element.barChart.lsSeries.forEach(element => {
                    etiquetado.push({
                        name: element.desValor,
                        data: element.lsValores
                    });
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });
                });

                bigWidthEtq = this.getHorizontal(etiquetado);
                bigWidthPes = this.getHorizontal(porcentajes);

                let grafica = {
                    pais: element.desPais,
                    paisId: element.paisId ? [element.paisId] : this.filtersForm.get('pais').value,
                    denominacionId: this.filtersForm.get('denominacion').value,
                    service: 'getRepKilosCampanyasDenominacionesExcelOrCsv',
                    serviceGrid: 'getEstGridKilosCampanyasDenominaciones',
                    valorMaximo,
                    categorias,
                    etiquetado,
                    porcentajes,
                    colores: coloresGrafica,
                    bigWidthEtq,
                    bigWidthPes
                };

                this.etiquetadoKilosCampanyasDenominaciones2.push(grafica);
            });
            setTimeout(resolve, 1);
        });
    }

    private graficasEtiquetado_KilosCampanyas_KilosPaisDenominaciones_3(): Promise<any> {
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            this.datosEtiquetado.etiquetado_KilosCampanyas_KilosPaisDenominaciones_3.forEach(element => {
                let etiquetado = [];
                let porcentajes = [];
                let categorias = [];
                let coloresGrafica = [];
                categorias = element.barChart.lsCategories;
                valorMaximo = element.barChart.valorMaximo;
                coloresGrafica = this.coloresSpline.slice(0, categorias.length);

                element.barChart.lsSeries.forEach(element => {
                    etiquetado.push({
                        name: element.desValor,
                        data: element.lsValores
                    });
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });
                });

                bigWidthEtq = this.getHorizontal(etiquetado);
                bigWidthPes = this.getHorizontal(porcentajes);

                let grafica = {
                    pais: element.desPais,
                    paisId: element.paisId ? [element.paisId] : this.filtersForm.get('pais').value,
                    denominacionId: element.denominacionId ? [element.denominacionId] : this.filtersForm.get('denominacion').value,
                    denominacion: element.desDenominacion,
                    service: 'getRepKilosCampanyasKilosPaisDenominacionesExcelOrCsv',
                    serviceGrid: 'getEstGridKilosCampanyasKilosPaisDenominaciones',
                    valorMaximo,
                    categorias,
                    etiquetado,
                    porcentajes,
                    colores: coloresGrafica,
                    bigWidthEtq,
                    bigWidthPes
                };

                this.etiquetadoKilosCampanyasKilosPaisDenominaciones3.push(grafica);
            });
            setTimeout(resolve, 1);
        });
    }

    private graficasEtiquetado_KilosCampanyasEtiquetadores_PaisDenominacion_1(): Promise<any> {
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            this.datosEtiquetadoFiltroCompleto.etiquetado_KilosCampanyasEtiquetadores_PaisDenominacion_1.forEach(element => {
                let etiquetado = [];
                let porcentajes = [];
                let categorias = [];
                let coloresGrafica = [];
                categorias = element.barChart.lsCategories;
                valorMaximo = element.barChart.valorMaximo;
                coloresGrafica = this.colores.slice(0, element.barChart.lsSeries.length);

                element.barChart.lsSeries.forEach(element => {
                    etiquetado.push({
                        name: element.desValor,
                        data: element.lsValores
                    });
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });
                });

                bigWidthEtq = this.getHorizontal(etiquetado);
                bigWidthPes = this.getHorizontal(porcentajes);

                let grafica = {
                    pais: element.desPais,
                    paisId: [element.paisId],
                    denominacion: element.desDenominacion,
                    denominacionId: [element.denominacionId],
                    campanyaId: this.filtersForm.get('anyoCampanya').value ? this.filtersForm.get('anyoCampanya').value : [],
                    service: 'getRepKilosCampanyasEtqExcelOrCsv',
                    serviceGrid: 'getEstGridKilosCampanyasEtq',
                    valorMaximo,
                    categorias,
                    etiquetado,
                    porcentajes,
                    colores: coloresGrafica,
                    bigWidthEtq,
                    bigWidthPes
                };

                this.etiquetadoKilosCampanyasEtiquetadoresPaisDenominacion1.push(grafica);
            });
            setTimeout(resolve, 1);
        });
    }

    private graficasEtiquetado_KilosEtiquetadores_AnyoPaisDenominacion_1(): Promise<any> {
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            this.datosEtiquetadoFiltroCompleto.etiquetado_KilosEtiquetadores_AnyoPaisDenominacion_1.forEach(element => {
                let etiquetado = [];
                let porcentajes = [];
                let categorias = [];
                let coloresGrafica = [];
                categorias = element.barChart.lsCategories;
                valorMaximo = element.barChart.valorMaximo;
                coloresGrafica = this.coloresSpline.slice(0, 2);

                element.barChart.lsSeries.forEach(element => {
                    etiquetado.push({
                        name: element.desValor,
                        data: element.lsValores
                    });
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });
                });

                bigWidthEtq = this.getHorizontal(etiquetado);
                bigWidthPes = this.getHorizontal(porcentajes);

                let grafica = {
                    pais: element.desPais,
                    paisId: [element.paisId],
                    denominacion: element.desDenominacion,
                    denominacionId: [element.denominacionId],
                    service: 'getRepKilosEtqExcelOrCsv',
                    serviceGrid: 'getEstGridKilosEtq',
                    anyo: element.anyo,
                    valorMaximo,
                    categorias,
                    etiquetado,
                    porcentajes,
                    colores: coloresGrafica,
                    bigWidthEtq,
                    bigWidthPes
                };

                this.etiquetadoKilosEtiquetadoresAnyoPaisDenominacion1.push(grafica);
            });
            setTimeout(resolve, 1);
        });
    }

    private graficasEtiquetado_KilosCampanyaPaisMes_PaisMesTotales_1(): Promise<any> {
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            this.datosEtiquetadoFiltroCompleto.etiquetado_KilosCampanyaPaisMes_PaisMesTotales_1.forEach(element => {
                let etiquetado = [];
                let porcentajes = [];
                let categorias = [];
                let coloresGrafica = [];
                categorias = element.barChart.lsCategories;
                valorMaximo = element.barChart.valorMaximo;
                coloresGrafica = this.colores.slice(0, categorias.length);

                element.barChart.lsSeries.forEach(element => {
                    etiquetado.push({
                        name: element.desValor,
                        data: element.lsValores
                    });
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });
                });

                bigWidthEtq = this.getHorizontal(etiquetado);
                bigWidthPes = this.getHorizontal(porcentajes);

                let grafica = {
                    pais: element.desPais,
                    denominacion: element.desDenominacion,
                    valorMaximo,
                    categorias,
                    etiquetado,
                    porcentajes,
                    colores: coloresGrafica,
                    bigWidthEtq,
                    bigWidthPes
                };

                this.etiquetadoKilosCampanyasEtiquetadoresPaisDenominacion1.push(grafica);
            });
            setTimeout(resolve, 1);
        });
    }

    private graficasEtiquetado_KilosEtiquetadorCampanyas_Denominaciones_1(): Promise<any> {
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            this.datosEtiquetadoFiltroEtiquetador.etiquetado_KilosEtiquetadorCampanyas_Denominaciones_1.forEach(element => {
                let etiquetado = [];
                let porcentajes = [];
                let categorias = [];
                let coloresGrafica = [];
                categorias = element.barChart.lsCategories;
                valorMaximo = element.barChart.valorMaximo;
                coloresGrafica = this.colores.slice(0, categorias.length);

                element.barChart.lsSeries.forEach(element => {
                    etiquetado.push({
                        name: element.desValor,
                        data: element.lsValores
                    });
                    porcentajes.push({
                        name: element.desValor,
                        data: element.lsPorcentajes
                    });
                });

                bigWidthEtq = this.getHorizontal(etiquetado);
                bigWidthPes = this.getHorizontal(porcentajes);

                let grafica = {
                    pais: element.desPais,
                    etiquetador: element.desEtiquetador,
                    paisId: [element.paisId],
                    etiquetadorId: element.etiquetadorId,
                    denominacionId: this.filtersForm.get('denominacion').value,
                    service: 'getRepKilosEtqCampanyasDenominacionesExcelOrCsv',
                    serviceGrid: 'getEstGridKilosEtqCampanyasDenominaciones',
                    valorMaximo,
                    categorias,
                    etiquetado,
                    porcentajes,
                    colores: coloresGrafica,
                    bigWidthEtq,
                    bigWidthPes
                };

                this.etiquetadoKilosEtiquetadorCampanyasDenominaciones1.push(grafica);
            });
            setTimeout(resolve, 1);
        });
    }

    private graficasEtiquetado_KilosEtiquetadorCampanyas_KilosDenominaciones_2(): Promise<any> {
        let valorMaximo;
        let bigWidthEtq;
        let bigWidthPes;

        return new Promise((resolve, reject) => {
            this.datosEtiquetadoFiltroEtiquetador.etiquetado_KilosEtiquetadorCampanyas_KilosDenominaciones_2.forEach(element => {
                let etiquetado = [];
                let porcentajes = [];
                let categorias = [];
                let coloresGrafica = [];
                categorias = element.barChart.lsCategories;
                valorMaximo = element.barChart.valorMaximo;
                coloresGrafica = this.coloresSpline.slice(0, categorias.length);

                element.barChart.lsSeries.forEach(element => {
                    etiquetado.push({
                        name: element.desValor,
                        data: element.lsValores
                    });

                    if (element.lsPorcentajes) {
                        porcentajes.push({
                            name: element.desValor,
                            data: element.lsPorcentajes
                        });
                        bigWidthPes = this.getHorizontal(porcentajes);
                    } else {
                        porcentajes = null;
                    }
                });

                bigWidthEtq = this.getHorizontal(etiquetado);

                let grafica = {
                    pais: element.desPais,
                    paisId: [element.paisId],
                    etiquetador: element.desEtiquetador,
                    etiquetadorId: element.etiquetadorId,
                    denominacion: element.desDenominacion,
                    denominacionId: [element.denominacionId],
                    service: 'getRepKilosEtqCampanyasDenominacionesKgExcelOrCsv',
                    serviceGrid: 'getEstGridKilosEtqCampanyasDenominacionesKg',
                    valorMaximo,
                    categorias,
                    etiquetado,
                    porcentajes,
                    colores: coloresGrafica,
                    bigWidthEtq,
                    bigWidthPes
                };

                this.etiquetadoKilosEtiquetadorCampanyasKilosDenominaciones2.push(grafica);
            });
            setTimeout(resolve, 1);
        });
    }

//#endregion

    shareCheckedListCampanyas(item: any[]) {
        this.filtersForm.get('anyoCampanya').patchValue(item);
    }

    shareCheckedListPaises(item: any[]) {
        this.filtersForm.get('pais').patchValue(item);
    }

    shareCheckedListDenominaciones(item: any[]) {
        this.filtersForm.get('denominacion').patchValue(item);
    }

    public checkWarnings(event) {
        if (event.filtroAnyo) {
            this.filtersForm.get('anyoCampanya').setValidators(Validators.required);
            this.filtersForm.get('anyoCampanya').updateValueAndValidity();
            this.filtroAnyo = true;
        } else {
            this.filtersForm.get('anyoCampanya').clearValidators();
            this.filtersForm.get('anyoCampanya').updateValueAndValidity();
            this.filtroAnyo = false;
        }

        if (event.filtroPais) {
            this.filtersForm.get('pais').setValidators(Validators.required);
            this.filtersForm.get('pais').updateValueAndValidity();
            this.filtroPais = true;
        } else {
            this.filtersForm.get('pais').clearValidators();
            this.filtersForm.get('pais').updateValueAndValidity();
            this.filtroPais = false;
        }

        if (event.filtroDenominacion) {
            this.filtersForm.get('denominacion').setValidators(Validators.required);
            this.filtersForm.get('denominacion').updateValueAndValidity();
            this.filtroDenominacion = true;
        } else {
            this.filtersForm.get('denominacion').clearValidators();
            this.filtersForm.get('denominacion').updateValueAndValidity();
            this.filtroDenominacion = false;
        }

        if (event.filtroEtiquetador) {
            this.filtersForm.get('etiquetador').setValidators(Validators.required);
            this.filtersForm.get('etiquetador').updateValueAndValidity();
            this.filtroEtiquetador = true;
        } else {
            this.filtersForm.get('etiquetador').clearValidators();
            this.filtersForm.get('etiquetador').updateValueAndValidity();
            this.filtroEtiquetador = false;
        }

        // if (this.filtroAnyo || this.filtroPais || this.filtroDenominacion || this.filtroEtiquetador) {
        //     this.mensajes = [];
        //     this.showError = true;
        //     this.filtersVisible = true;
        //     this.mensajes.push({ class: 'error', message: 'global.info.filterRequired' });
        // } else {
        //     this.showError = false;
        //     this.filtersVisible = true;
        //     this.mensajes = [];
        // }

        if (event.hasOwnProperty('tab3Etiquetado')) {
            this.otherFilter = 3;
            if (this.paises.length > 1) {
                this.filtersForm.get('pais').enable();
                this.disabledPaises.next(false);
            }
            this.disabledEtiquetadores.next(true);
            this.filtersForm.get('etiquetador').reset();
            this.filtersForm.get('etiquetador').disable();
        } else if (event.hasOwnProperty('tab6Etiquetdao')) {
            this.otherFilter = 6;
            if (this.paises.length > 1) {
                this.disabledPaises.next(true);
                this.filtersForm.get('pais').reset();
                this.filtersForm.get('pais').disable();
            }
            this.disabledEtiquetadores.next(false);
            this.filtersForm.get('etiquetador').enable();
        } else if (event.hasOwnProperty('tab11')) {
            this.otherFilter = 11;
        } else {
            this.filtersForm.get('etiquetador').reset();
            this.otherFilter = 0;
        }

        if (this.filtersForm.get('anyoCampanya').enabled) {
            this.filtersForm.get('anyoCampanya').setValidators(Validators.nullValidator);
            this.filtersForm.get('anyoCampanya').updateValueAndValidity();
        }
    }

    public getHorizontal(data: any): boolean {
        return data.some((item) => {
            if (item && item.data && item.data.length > 7) {
                return true;
            } else {
                return false;
            }
        });
    }

    public getHorizontalBar(data: any): boolean {
        return ((data && data.length > 7) ? true : false);
    }

    public mostrarFiltrado() {
        return (this.filterCultivos || this.filterCultivos || this.filterDesignacionesPD ||
                this.filterDesignacionesCPD || this.filterEtiquetadoPD || this.filterEtiquetadoCPD) ? true : false;
    }

    public checkNullValues() {
        if (this.filtersForm.get('anyoCampanya').enabled) {
            if (this.filtersForm.get('anyoCampanya').value === null) {
                return false;
            }
        }

        if (this.filtersForm.get('pais').enabled) {
            if (this.filtersForm.get('pais').value === null) {
                return false;
            }
        }

        if (this.filtersForm.get('denominacion').enabled) {
            if (this.filtersForm.get('denominacion').value === null) {
                return false;
            }
        }

        return true;
    }

    public openDocHelp() {
      this._spinnerService.showSpinner();
      this.toCloseSpinner += 1;
      this._dataService.getDocHelp('Data_Insigths_Statistics_Hub.pdf').toPromise().finally(() => {
          this.checkCloseSpinner();
      }).then((resp) => {
          localStorage.setItem('base64', resp.base64Archivo);
          const url = this._router.serializeUrl(this._router.createUrlTree(['viewPdf']));
          window.open(url, '_blank');
      });
    }
}
